// Translations for Opora Vie
// Languages: FR (French), EN (English), IT (Italian), RU (Russian), RO (Romanian)

export const translations = {
  fr: {
    // Navigation
    nav: {
      findPractitioner: "Trouver un praticien",
      login: "Connexion",
      register: "Inscription",
      becomePractitioner: "Devenir Praticien",
      mySpace: "Mon espace",
      myPractitionerProfile: "Mon profil praticien",
      logout: "Déconnexion",
      about: "À propos",
      resources: "Ressources",
      practicalInfo: "Infos pratiques",
      resourcesGuides: "Guides & Conseils",
      blog: "Blog / Actualités"
    },
    // Landing Page
    landing: {
      badge: "Le 1er portail mondial pour praticiens en médecine douce originaires d'Europe de l'Est",
      title: "Trouvez votre praticien de bien-être",
      titleHighlight: "partout dans le monde",
      subtitle: "Vous avez quitté votre pays, vous vivez loin de votre famille, vous êtes en état de détresse, vous traversez une période difficile ? Nous sommes une ligne d'écoute, nos thérapeutes, naturopathes, sophrologues et psychologues sont là pour vous écouter et vous accompagner. Que vous soyez en Europe ou partout ailleurs dans le monde, vous n'êtes plus seuls.",
      searchSpecialty: "Spécialité",
      searchSpecialtyPlaceholder: "Choisir une spécialité",
      searchCity: "Ville",
      searchCityPlaceholder: "Paris, Lyon, Marseille...",
      searchButton: "Rechercher",
      easyBooking: "Réservation facile",
      easyBookingDesc: "24h/24, 7j/7",
      specialtiesTitle: "Nos spécialités",
      specialtiesSubtitle: "Des praticiens qualifiés qui comprennent votre culture et parlent votre langue",
      featuredTitle: "Praticiens à découvrir",
      featuredSubtitle: "Consultez les profils de nos praticiens et prenez rendez-vous",
      viewAll: "Voir tous les praticiens",
      perConsultation: "/ consultation",
      whyChooseTitle: "Pourquoi nous choisir ?",
      whyChooseSubtitle: "Une plateforme qui rapproche les communautés venant de l'Est",
      feature1Title: "Soutien et écoute",
      feature1Desc: "Séparation familiale, adaptation à un nouveau pays, anxiété, problèmes personnels ou professionnels - nos spécialistes sont là pour vous écouter",
      feature2Title: "Praticiens de votre culture",
      feature2Desc: "Trouvez des praticiens qui comprennent votre parcours, parlent votre langue et connaissent vos traditions",
      feature3Title: "Disponibles partout",
      feature3Desc: "En cabinet ou en visio, nos praticiens vous accompagnent où que vous soyez dans le monde",
      ctaTitle: "Vous êtes praticien ?",
      ctaSubtitle: "Rejoignez notre réseau de praticiens originaires d'Europe de l'Est. Aidez vos compatriotes expatriés à travers le monde.",
      ctaButton: "Créer mon profil praticien",
      testimonialTitle: "Ce que disent nos utilisateurs",
      testimonialSubtitle: "Découvrez les témoignages de personnes qui ont trouvé du soutien grâce à nos praticiens",
      allRights: "Tous droits réservés.",
      gdprCompliant: "Conforme RGPD",
      dataProtection: "Vos données sont protégées",
      securePayments: "Paiements sécurisés",
      poweredByStripe: "Via Stripe",
      sslEncrypted: "Chiffrement SSL",
      secureConnection: "Connexion sécurisée"
    },
    // Testimonials
    testimonials: [
      {
        name: "Marie Dupont",
        location: "Paris",
        text: "Grâce à Opora Vie, j'ai trouvé une naturopathe exceptionnelle près de chez moi. La prise de rendez-vous est simple et rapide !",
        rating: 5
      },
      {
        name: "Jean-Pierre Martin",
        location: "Lyon",
        text: "Excellent service ! Mon sophrologue m'aide beaucoup à gérer mon stress. Je recommande cette plateforme à tous.",
        rating: 5
      },
      {
        name: "Sophie Bernard",
        location: "Marseille",
        text: "Enfin une plateforme qui regroupe tous les praticiens de médecine douce. Très pratique pour comparer et choisir.",
        rating: 5
      }
    ],
    // Une Page
    une: {
      founders: "Les Fondateurs",
      featured: "À la une",
      featuredSubtitle: "Découvrez nos praticiens à travers leurs vidéos de présentation",
      noVideo: "Aucune vidéo à la une pour le moment",
      ctaTitle: "Rejoignez notre communauté",
      ctaSubtitle: "Que vous soyez praticien ou à la recherche d'un accompagnement, Apora vous connecte avec les meilleurs professionnels du bien-être.",
      findPractitioner: "Trouver un praticien",
      becomePractitioner: "Devenir praticien"
    },
    // Search Page
    search: {
      title: "Trouver un praticien",
      practitionersAvailable: "praticien(s) disponible(s)",
      filters: "Filtres",
      clear: "Effacer",
      specialty: "Spécialité",
      allSpecialties: "Toutes les spécialités",
      country: "Pays",
      allCountries: "Tous les pays",
      region: "Région",
      allRegions: "Toutes les régions",
      department: "Département",
      allDepartments: "Tous les départements",
      city: "Ville",
      cityPlaceholder: "Rechercher une ville",
      consultationType: "Type de consultation",
      allTypes: "Tous les types",
      cabinet: "En cabinet",
      video: "En visio",
      applyFilters: "Appliquer les filtres",
      noPractitionerFound: "Aucun praticien trouvé",
      featuredPractitioners: "Praticiens à découvrir",
      tryDifferentCriteria: "Essayez de modifier vos critères de recherche",
      clearFilters: "Effacer les filtres",
      listView: "Liste",
      mapView: "Carte",
      noLocationAvailable: "Aucun praticien avec localisation disponible"
    },
    // Auth Page
    auth: {
      welcome: "Bienvenue sur Opora Vie",
      welcomeSubtitle: "Trouvez le praticien idéal pour votre bien-être ou développez votre activité de praticien.",
      backToHome: "Retour à l'accueil",
      login: "Connexion",
      register: "Inscription",
      welcomeBack: "Bon retour !",
      connectToAccount: "Connectez-vous à votre compte",
      email: "Email",
      emailProfessional: "Email professionnel",
      password: "Mot de passe",
      passwordMinChars: "Minimum 6 caractères",
      loginButton: "Se connecter",
      createAccount: "Créer un compte",
      joinUs: "Rejoignez Opora Vie",
      joinPlatform: "Rejoignez la plateforme en moins d'une minute.",
      iAm: "Je suis",
      client: "Client",
      clientDesc: "Je cherche un praticien",
      practitioner: "Praticien",
      practitionerDesc: "Je propose mes services",
      iAmClient: "Je suis client",
      iAmPractitioner: "Je suis praticien",
      firstName: "Prénom",
      lastName: "Nom",
      phone: "Téléphone",
      phoneOptional: "Téléphone (optionnel)",
      createMyAccount: "Créer mon compte",
      identityVerification: "Vérification d'identité",
      verificationExplanation: "Saisissez votre nom et votre email professionnel. Nous vous enverrons un code à 8 caractères pour valider votre inscription (valide 7 jours).",
      sendMyCode: "Envoyer mon code",
      codeReceived: "Code envoyé !",
      checkEmail: "Un code a été envoyé à votre adresse email. Vérifiez également vos spams.",
      accessCode: "Code d'accès",
      verifyCode: "Vérifier le code",
      resendCode: "← Renvoyer un code",
      codeVerifiedSuccess: "Code vérifié avec succès !",
      createYourPassword: "Créez maintenant votre mot de passe.",
      alreadyHaveAccount: "Déjà un compte ?",
      loginLink: "Se connecter",
      gdprCompliant: "Conforme RGPD",
      securePayments: "Paiements sécurisés via Stripe",
      dataProtection: "Protection des données",
      // Practitioner signup page
      practitionerSignupTitle: "Inscription Praticien",
      practitionerSignupSubtitle: "Créez votre compte pour commencer à recevoir des clients",
      joinOpora: "Rejoignez Opora Vie",
      joinOporaSubtitle: "Développez votre activité de praticien et connectez-vous avec des clients qui recherchent vos services.",
      benefit1Title: "Visibilité accrue",
      benefit1Desc: "Soyez trouvé par des clients dans votre région",
      benefit2Title: "Gestion simplifiée",
      benefit2Desc: "Gérez vos rendez-vous et disponibilités facilement",
      benefit3Title: "Consultations en ligne",
      benefit3Desc: "Proposez des séances en visioconférence",
      benefit4Title: "Paiement sécurisé",
      benefit4Desc: "Recevez des paiements en ligne via Stripe",
      createPractitionerAccount: "Créer mon compte praticien",
      creatingAccount: "Création en cours...",
      alreadyRegistered: "Déjà inscrit ?",
      loginLink: "Se connecter"
    },
    // Booking
    booking: {
      bookWith: "Réserver avec",
      chooseDate: "Choisir une date",
      chooseTime: "Choisir un horaire",
      noSlotAvailable: "Aucun créneau disponible pour cette date",
      consultationType: "Type de consultation",
      inOffice: "En cabinet",
      onSite: "Sur place",
      videoCall: "En visio",
      remote: "À distance",
      notes: "Notes (optionnel)",
      notesPlaceholder: "Décrivez brièvement la raison de votre consultation...",
      confirmAppointment: "Confirmer le rendez-vous",
      bookingInProgress: "Réservation en cours...",
      summary: "Récapitulatif",
      date: "Date",
      time: "Heure",
      type: "Type",
      duration: "Durée",
      total: "Total",
      paymentOnSite: "Paiement sur place",
      payOnline: "Payer en ligne",
      appointmentConfirmed: "Rendez-vous confirmé !",
      appointmentConfirmedDesc: "a bien été enregistré.",
      viewMyAppointments: "Voir mes rendez-vous",
      searchMorePractitioners: "Rechercher d'autres praticiens",
      proceedToPayment: "Procéder au paiement"
    },
    // Dashboard
    dashboard: {
      hello: "Bonjour",
      manageAppointments: "Gérez vos rendez-vous et votre profil",
      upcoming: "À venir",
      past: "Passés",
      cancelled: "Annulés",
      noUpcoming: "Aucun rendez-vous à venir",
      findPractitioner: "Trouvez un praticien et réservez votre première consultation",
      searchPractitioner: "Rechercher un praticien",
      noPast: "Aucun rendez-vous passé",
      pastWillAppear: "Vos consultations passées apparaîtront ici",
      noCancelled: "Aucun rendez-vous annulé",
      cancelledWillAppear: "Vos annulations apparaîtront ici",
      viewProfile: "Voir le profil",
      cancel: "Annuler",
      myProfile: "Mon profil",
      save: "Enregistrer",
      saving: "Enregistrement...",
      joinVideoCall: "Rejoindre la consultation vidéo"
    },
    // Practitioner Dashboard
    practitionerDashboard: {
      manageAppointmentsAndAvailability: "Gérez vos rendez-vous et vos disponibilités",
      editProfile: "Modifier mon profil",
      totalAppointments: "Total RDV",
      pending: "En attente",
      confirmed: "Confirmés",
      completed: "Terminés",
      history: "Historique",
      noUpcoming: "Aucun rendez-vous à venir",
      upcomingWillAppear: "Vos prochains rendez-vous apparaîtront ici",
      noHistory: "Aucun historique",
      pastWillAppear: "Vos consultations passées apparaîtront ici",
      confirm: "Confirmer",
      refuse: "Refuser",
      markComplete: "Marquer terminé",
      statistics: "Statistiques",
      noData: "Aucune donnée disponible",
      quickActions: "Actions rapides",
      viewPublicPage: "Voir ma page publique",
      googleCalendar: "Google Calendar",
      connected: "Connecté - vos RDV sont synchronisés",
      syncDescription: "Synchronisez automatiquement vos rendez-vous avec Google Calendar",
      connectGoogleCalendar: "Connecter Google Calendar",
      notConfigured: "Google Calendar non configuré sur ce serveur"
    },
    // About Page
    about: {
      title: "À propos de Opora Vie",
      subtitle: "Votre plateforme de mise en relation avec des praticiens de bien-être",
      missionTitle: "Notre mission",
      missionText: "Opora Vie a été créé pour faciliter l'accès aux médecines douces et au bien-être. Notre plateforme met en relation les personnes en quête de mieux-être avec des praticiens qualifiés à toutes heures dans leur région et pays au niveau mondial.",
      valuesTitle: "Nos valeurs",
      value1Title: "Accessibilité",
      value1Desc: "Rendre les médecines douces accessibles à tous, partout en France et à l'international.",
      value2Title: "Qualité",
      value2Desc: "Sélectionner des praticiens qualifiés et certifiés dans leur domaine d'expertise.",
      value3Title: "Confiance",
      value3Desc: "Créer un environnement de confiance entre les praticiens et leurs patients.",
      locationTitle: "Notre localisation",
      locationSubtitle: "Basés dans les Yvelines (78), nous servons toute la France et l'international",
      addressTitle: "Adresse",
      addressPlaceholder: "Adresse à définir",
      yvelinesDesc: "Département des Yvelines (78) - Île-de-France",
      contactTitle: "Nous contacter",
      contactEmail: "contact@apora.net"
    },
    // Specialties
    specialties: {
      therapeute: "Thérapeute",
      naturopathe: "Naturopathe",
      sophrologue: "Sophrologue",
      psychologue: "Psychologue",
      osteopathe: "Ostéopathe",
      hypnotherapeute: "Hypnothérapeute",
      coach: "Coach",
      orthophoniste: "Orthophoniste"
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      back: "Retour",
      next: "Suivant",
      minutes: "min",
      euro: "€"
    },
    // Payment
    payment: {
      paymentRequired: "Paiement requis",
      paymentDescription: "Finalisez votre réservation en effectuant le paiement",
      processing: "Traitement en cours...",
      success: "Paiement réussi !",
      failed: "Paiement échoué",
      cancelled: "Paiement annulé",
      tryAgain: "Réessayer"
    },
    // Practitioner Signup
    practitionerSignup: {
      title: "Devenir Praticien",
      subtitle: "Rejoignez la communauté Opora Vie",
      backToHome: "Retour à l'accueil",
      step1Title: "Étape 1 : Demande d'accès",
      step1Desc: "Remplissez vos informations. Nous vous enverrons un code d'accès par email.",
      step2Title: "Étape 2 : Vérification du code",
      step2Desc: "Un code d'accès vous a été envoyé par email à",
      step3Title: "Étape 3 : Contrat praticien",
      step3Desc: "Veuillez lire et accepter les conditions du contrat",
      step5Title: "Étape 5 : Créez votre compte",
      step5Desc: "Finalisez votre inscription en créant vos identifiants",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      password: "Mot de passe",
      passwordMin: "caractères minimum",
      accessCode: "Code d'accès",
      accessCodePlaceholder: "Entrez le code reçu par email",
      sendRequest: "Envoyer ma demande",
      verifyCode: "Vérifier le code",
      noCodeReceived: "Vous n'avez pas reçu de code ?",
      resendRequest: "Renvoyer la demande",
      downloadContract: "Télécharger le contrat (PDF)",
      acceptTerms: "J'ai lu et j'accepte les conditions générales du contrat d'accès praticien. Je comprends que des frais d'inscription de",
      willBeCharged: "seront prélevés.",
      acceptAndPay: "Accepter et payer",
      createAccount: "Créer mon compte praticien",
      paymentReceived: "Paiement reçu - Contrat accepté",
      alreadyAccount: "Déjà un compte ?",
      login: "Se connecter",
      requestSent: "Demande envoyée ! Vous recevrez un code par email.",
      codeVerified: "Code vérifié ! Veuillez lire et accepter le contrat.",
      paymentSuccess: "Paiement réussi ! Créez maintenant votre compte.",
      accountCreated: "Compte praticien créé avec succès !",
      mustAcceptTerms: "Vous devez accepter les conditions du contrat",
      passwordTooShort: "Le mot de passe doit contenir au moins 16 caractères",
      sending: "Envoi en cours...",
      verifying: "Vérification...",
      redirectingPayment: "Redirection vers le paiement...",
      creating: "Création en cours..."
    }
  },
  en: {
    nav: {
      findPractitioner: "Find a practitioner",
      login: "Login",
      register: "Sign up",
      becomePractitioner: "Become a Practitioner",
      mySpace: "My space",
      myPractitionerProfile: "My practitioner profile",
      logout: "Logout",
      about: "About",
      resources: "Resources",
      practicalInfo: "Practical Info",
      resourcesGuides: "Guides & Tips",
      blog: "Blog / News"
    },
    landing: {
      badge: "The #1 worldwide platform for natural medicine practitioners from Eastern Europe",
      title: "Find your wellness practitioner",
      titleHighlight: "anywhere in the world",
      subtitle: "Have you left your country? Living far from family? In distress? Going through a difficult time? We are a listening line. Our therapists, naturopaths, sophrologists and psychologists are here to listen and support you. Whether in Europe or anywhere else in the world - you are no longer alone.",
      searchSpecialty: "Specialty",
      searchSpecialtyPlaceholder: "Choose a specialty",
      searchCity: "City",
      searchCityPlaceholder: "Paris, Lyon, Marseille...",
      searchButton: "Search",
      easyBooking: "Easy booking",
      easyBookingDesc: "24/7",
      specialtiesTitle: "Our specialties",
      specialtiesSubtitle: "Qualified practitioners who understand your culture and speak your language",
      featuredTitle: "Featured practitioners",
      featuredSubtitle: "Browse our practitioners' profiles and book an appointment",
      viewAll: "View all practitioners",
      perConsultation: "/ consultation",
      whyChooseTitle: "Why choose us?",
      whyChooseSubtitle: "A platform connecting Eastern European communities worldwide",
      feature1Title: "Support and listening",
      feature1Desc: "Family separation, adapting to a new country, anxiety, personal or professional issues - our specialists are here to listen",
      feature2Title: "Practitioners from your culture",
      feature2Desc: "Find practitioners who understand your journey, speak your language and know your traditions",
      feature3Title: "Available everywhere",
      feature3Desc: "In-office or via video call, our practitioners support you wherever you are in the world",
      ctaTitle: "Are you a practitioner?",
      ctaSubtitle: "Join our network of Eastern European practitioners. Help your expatriate compatriots around the world.",
      ctaButton: "Create my practitioner profile",
      testimonialTitle: "What our users say",
      testimonialSubtitle: "Discover testimonials from people who found support through our practitioners",
      allRights: "All rights reserved.",
      gdprCompliant: "GDPR Compliant",
      dataProtection: "Your data is protected",
      securePayments: "Secure Payments",
      poweredByStripe: "Powered by Stripe",
      sslEncrypted: "SSL Encrypted",
      secureConnection: "Secure connection"
    },
    testimonials: [
      {
        name: "Marie Dupont",
        location: "Paris",
        text: "Thanks to Opora Vie, I found an exceptional naturopath near me. Booking an appointment is simple and fast!",
        rating: 5
      },
      {
        name: "Jean-Pierre Martin",
        location: "Lyon",
        text: "Excellent service! My sophrologist helps me a lot with managing stress. I recommend this platform to everyone.",
        rating: 5
      },
      {
        name: "Sophie Bernard",
        location: "Marseille",
        text: "Finally a platform that brings together all natural medicine practitioners. Very practical for comparing and choosing.",
        rating: 5
      }
    ],
    search: {
      title: "Find a practitioner",
      practitionersAvailable: "practitioner(s) available",
      filters: "Filters",
      clear: "Clear",
      specialty: "Specialty",
      allSpecialties: "All specialties",
      country: "Country",
      allCountries: "All countries",
      region: "Region",
      allRegions: "All regions",
      department: "Department",
      allDepartments: "All departments",
      city: "City",
      cityPlaceholder: "Search a city",
      consultationType: "Consultation type",
      allTypes: "All types",
      cabinet: "In office",
      video: "Video call",
      applyFilters: "Apply filters",
      noPractitionerFound: "No practitioner found",
      featuredPractitioners: "Featured practitioners",
      tryDifferentCriteria: "Try modifying your search criteria",
      clearFilters: "Clear filters",
      listView: "List",
      mapView: "Map",
      noLocationAvailable: "No practitioner with location available"
    },
    auth: {
      welcome: "Welcome to Opora Vie",
      welcomeSubtitle: "Find the ideal practitioner for your well-being or grow your practice.",
      backToHome: "Back to home",
      login: "Login",
      register: "Sign up",
      welcomeBack: "Welcome back!",
      connectToAccount: "Sign in to your account",
      email: "Email",
      emailProfessional: "Professional email",
      password: "Password",
      passwordMinChars: "Minimum 6 characters",
      loginButton: "Sign in",
      createAccount: "Create an account",
      joinUs: "Join Opora Vie",
      joinPlatform: "Join the platform in less than a minute.",
      iAm: "I am",
      client: "Client",
      clientDesc: "I'm looking for a practitioner",
      practitioner: "Practitioner",
      practitionerDesc: "I offer my services",
      iAmClient: "I am a client",
      iAmPractitioner: "I am a practitioner",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      phoneOptional: "Phone (optional)",
      createMyAccount: "Create my account",
      identityVerification: "Identity verification",
      verificationExplanation: "Enter your name and professional email. We will send you an 8-character code to validate your registration (valid for 7 days).",
      sendMyCode: "Send my code",
      codeReceived: "Code sent!",
      checkEmail: "A code has been sent to your email address. Also check your spam folder.",
      accessCode: "Access code",
      verifyCode: "Verify code",
      resendCode: "← Resend a code",
      codeVerifiedSuccess: "Code verified successfully!",
      createYourPassword: "Now create your password.",
      alreadyHaveAccount: "Already have an account?",
      loginLink: "Sign in",
      gdprCompliant: "GDPR Compliant",
      securePayments: "Secure payments via Stripe",
      dataProtection: "Data protection",
      practitionerSignupTitle: "Practitioner Registration",
      practitionerSignupSubtitle: "Create your account to start receiving clients",
      joinOpora: "Join Opora Vie",
      joinOporaSubtitle: "Grow your practice and connect with clients looking for your services.",
      benefit1Title: "Increased visibility",
      benefit1Desc: "Be found by clients in your area",
      benefit2Title: "Simplified management",
      benefit2Desc: "Easily manage your appointments and availability",
      benefit3Title: "Online consultations",
      benefit3Desc: "Offer video conference sessions",
      benefit4Title: "Secure payment",
      benefit4Desc: "Receive online payments via Stripe",
      createPractitionerAccount: "Create my practitioner account",
      creatingAccount: "Creating account...",
      alreadyRegistered: "Already registered?",
      loginLink: "Sign in"
    },
    booking: {
      bookWith: "Book with",
      chooseDate: "Choose a date",
      chooseTime: "Choose a time",
      noSlotAvailable: "No slot available for this date",
      consultationType: "Consultation type",
      inOffice: "In office",
      onSite: "On site",
      videoCall: "Video call",
      remote: "Remote",
      notes: "Notes (optional)",
      notesPlaceholder: "Briefly describe the reason for your consultation...",
      confirmAppointment: "Confirm appointment",
      bookingInProgress: "Booking in progress...",
      summary: "Summary",
      date: "Date",
      time: "Time",
      type: "Type",
      duration: "Duration",
      total: "Total",
      paymentOnSite: "Payment on site",
      payOnline: "Pay online",
      appointmentConfirmed: "Appointment confirmed!",
      appointmentConfirmedDesc: "has been registered.",
      viewMyAppointments: "View my appointments",
      searchMorePractitioners: "Search more practitioners",
      proceedToPayment: "Proceed to payment"
    },
    dashboard: {
      hello: "Hello",
      manageAppointments: "Manage your appointments and profile",
      upcoming: "Upcoming",
      past: "Past",
      cancelled: "Cancelled",
      noUpcoming: "No upcoming appointments",
      findPractitioner: "Find a practitioner and book your first consultation",
      searchPractitioner: "Search a practitioner",
      noPast: "No past appointments",
      pastWillAppear: "Your past consultations will appear here",
      noCancelled: "No cancelled appointments",
      cancelledWillAppear: "Your cancellations will appear here",
      viewProfile: "View profile",
      cancel: "Cancel",
      myProfile: "My profile",
      save: "Save",
      saving: "Saving...",
      joinVideoCall: "Join video consultation"
    },
    practitionerDashboard: {
      manageAppointmentsAndAvailability: "Manage your appointments and availability",
      editProfile: "Edit my profile",
      totalAppointments: "Total appointments",
      pending: "Pending",
      confirmed: "Confirmed",
      completed: "Completed",
      history: "History",
      noUpcoming: "No upcoming appointments",
      upcomingWillAppear: "Your upcoming appointments will appear here",
      noHistory: "No history",
      pastWillAppear: "Your past consultations will appear here",
      confirm: "Confirm",
      refuse: "Refuse",
      markComplete: "Mark complete",
      statistics: "Statistics",
      noData: "No data available",
      quickActions: "Quick actions",
      viewPublicPage: "View my public page",
      googleCalendar: "Google Calendar",
      connected: "Connected - your appointments are synced",
      syncDescription: "Automatically sync your appointments with Google Calendar",
      connectGoogleCalendar: "Connect Google Calendar",
      notConfigured: "Google Calendar not configured on this server"
    },
    about: {
      title: "About Opora Vie",
      subtitle: "Your platform connecting you with wellness practitioners",
      missionTitle: "Our mission",
      missionText: "Opora Vie was created to facilitate access to natural medicine and wellness. Our platform connects people seeking better health with qualified practitioners around the clock in their region and country worldwide.",
      valuesTitle: "Our values",
      value1Title: "Accessibility",
      value1Desc: "Making natural medicine accessible to everyone, throughout France and internationally.",
      value2Title: "Quality",
      value2Desc: "Selecting qualified and certified practitioners in their field of expertise.",
      value3Title: "Trust",
      value3Desc: "Creating an environment of trust between practitioners and their patients.",
      locationTitle: "Our location",
      locationSubtitle: "Based in Yvelines (78), we serve all of France and internationally",
      addressTitle: "Address",
      addressPlaceholder: "Address to be defined",
      yvelinesDesc: "Yvelines Department (78) - Île-de-France",
      contactTitle: "Contact us",
      contactEmail: "contact@apora.net"
    },
    specialties: {
      therapeute: "Therapist",
      naturopathe: "Naturopath",
      sophrologue: "Sophrologist",
      psychologue: "Psychologist",
      osteopathe: "Osteopath",
      hypnotherapeute: "Hypnotherapist",
      coach: "Coach",
      orthophoniste: "Speech Therapist"
    },
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      back: "Back",
      next: "Next",
      minutes: "min",
      euro: "€"
    },
    payment: {
      paymentRequired: "Payment required",
      paymentDescription: "Complete your booking by making the payment",
      processing: "Processing...",
      success: "Payment successful!",
      failed: "Payment failed",
      cancelled: "Payment cancelled",
      tryAgain: "Try again"
    },
    practitionerSignup: {
      title: "Become a Practitioner",
      subtitle: "Join the Opora Vie community",
      backToHome: "Back to home",
      step1Title: "Step 1: Access Request",
      step1Desc: "Fill in your information. We will send you an access code by email.",
      step2Title: "Step 2: Code Verification",
      step2Desc: "An access code has been sent to your email at",
      step3Title: "Step 3: Practitioner Contract",
      step3Desc: "Please read and accept the contract terms",
      step5Title: "Step 5: Create Your Account",
      step5Desc: "Complete your registration by creating your credentials",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      password: "Password",
      passwordMin: "characters minimum",
      accessCode: "Access Code",
      accessCodePlaceholder: "Enter the code received by email",
      sendRequest: "Send my request",
      verifyCode: "Verify code",
      noCodeReceived: "Didn't receive a code?",
      resendRequest: "Resend request",
      downloadContract: "Download contract (PDF)",
      acceptTerms: "I have read and accept the general terms and conditions of the practitioner access contract. I understand that a registration fee of",
      willBeCharged: "will be charged.",
      acceptAndPay: "Accept and pay",
      createAccount: "Create my practitioner account",
      paymentReceived: "Payment received - Contract accepted",
      alreadyAccount: "Already have an account?",
      login: "Log in",
      requestSent: "Request sent! You will receive a code by email.",
      codeVerified: "Code verified! Please read and accept the contract.",
      paymentSuccess: "Payment successful! Now create your account.",
      accountCreated: "Practitioner account created successfully!",
      mustAcceptTerms: "You must accept the contract terms",
      passwordTooShort: "Password must be at least 16 characters",
      sending: "Sending...",
      verifying: "Verifying...",
      redirectingPayment: "Redirecting to payment...",
      creating: "Creating..."
    }
  },
  it: {
    nav: {
      findPractitioner: "Trova un professionista",
      login: "Accesso",
      register: "Registrazione",
      becomePractitioner: "Diventa Professionista",
      mySpace: "Il mio spazio",
      myPractitionerProfile: "Il mio profilo professionale",
      logout: "Esci",
      about: "Chi siamo",
      resources: "Risorse",
      practicalInfo: "Info pratiche",
      resourcesGuides: "Guide & Consigli",
      blog: "Blog / Notizie"
    },
    landing: {
      badge: "Il primo portale mondiale per professionisti della medicina naturale dall'Europa dell'Est",
      title: "Trova il tuo professionista del benessere",
      titleHighlight: "ovunque nel mondo",
      subtitle: "Hai lasciato il tuo paese? Vivi lontano dalla famiglia? Sei in difficoltà, stai attraversando un momento difficile? Siamo una linea di ascolto. I nostri terapeuti, naturopati, sofrologi e psicologi sono qui per ascoltarti e accompagnarti. Che tu sia in Europa o altrove nel mondo, non sei più solo.",
      searchSpecialty: "Specialità",
      searchSpecialtyPlaceholder: "Scegli una specialità",
      searchCity: "Città",
      searchCityPlaceholder: "Parigi, Lione, Marsiglia...",
      searchButton: "Cerca",
      easyBooking: "Prenotazione facile",
      easyBookingDesc: "24 ore su 24, 7 giorni su 7",
      specialtiesTitle: "Le nostre specialità",
      specialtiesSubtitle: "Professionisti qualificati che capiscono la tua cultura e parlano la tua lingua",
      featuredTitle: "Professionisti in evidenza",
      featuredSubtitle: "Consulta i profili dei nostri professionisti e prenota un appuntamento",
      viewAll: "Vedi tutti i professionisti",
      perConsultation: "/ consulto",
      whyChooseTitle: "Perché sceglierci?",
      whyChooseSubtitle: "Una piattaforma che avvicina le comunità dell'Est",
      feature1Title: "Supporto e ascolto",
      feature1Desc: "Separazione familiare, adattamento a un nuovo paese, ansia, problemi personali o professionali - i nostri specialisti sono qui per ascoltarti",
      feature2Title: "Professionisti della tua cultura",
      feature2Desc: "Trova professionisti che capiscono il tuo percorso, parlano la tua lingua e conoscono le tue tradizioni",
      feature3Title: "Disponibili ovunque",
      feature3Desc: "In studio o in video, i nostri professionisti ti supportano ovunque tu sia nel mondo",
      ctaTitle: "Sei un professionista?",
      ctaSubtitle: "Unisciti alla nostra rete di professionisti dall'Europa dell'Est. Aiuta i tuoi compatrioti espatriati in tutto il mondo.",
      ctaButton: "Crea il mio profilo professionale",
      testimonialTitle: "Cosa dicono i nostri utenti",
      testimonialSubtitle: "Scopri le testimonianze di persone che hanno trovato supporto grazie ai nostri professionisti",
      allRights: "Tutti i diritti riservati."
    },
    testimonials: [
      {
        name: "Marie Dupont",
        location: "Parigi",
        text: "Grazie a Opora Vie, ho trovato un'eccezionale naturopata vicino a me. La prenotazione è semplice e veloce!",
        rating: 5
      },
      {
        name: "Jean-Pierre Martin",
        location: "Lione",
        text: "Servizio eccellente! Il mio sofrologo mi aiuta molto a gestire lo stress. Consiglio questa piattaforma a tutti.",
        rating: 5
      },
      {
        name: "Sophie Bernard",
        location: "Marsiglia",
        text: "Finalmente una piattaforma che riunisce tutti i professionisti della medicina naturale. Molto pratico per confrontare e scegliere.",
        rating: 5
      }
    ],
    search: {
      title: "Trova un professionista",
      practitionersAvailable: "professionista/i disponibile/i",
      filters: "Filtri",
      clear: "Cancella",
      specialty: "Specialità",
      allSpecialties: "Tutte le specialità",
      country: "Paese",
      allCountries: "Tutti i paesi",
      region: "Regione",
      allRegions: "Tutte le regioni",
      department: "Dipartimento",
      allDepartments: "Tutti i dipartimenti",
      city: "Città",
      cityPlaceholder: "Cerca una città",
      consultationType: "Tipo di consulto",
      allTypes: "Tutti i tipi",
      cabinet: "In studio",
      video: "Videochiamata",
      applyFilters: "Applica filtri",
      noPractitionerFound: "Nessun professionista trovato",
      featuredPractitioners: "Professionisti in evidenza",
      tryDifferentCriteria: "Prova a modificare i criteri di ricerca",
      clearFilters: "Cancella filtri",
      listView: "Lista",
      mapView: "Mappa",
      noLocationAvailable: "Nessun professionista con posizione disponibile"
    },
    auth: {
      welcome: "Benvenuto su Opora Vie",
      welcomeSubtitle: "Trova il professionista ideale per il tuo benessere o sviluppa la tua attività.",
      backToHome: "Torna alla home",
      login: "Accesso",
      register: "Registrazione",
      welcomeBack: "Bentornato!",
      connectToAccount: "Accedi al tuo account",
      email: "Email",
      emailProfessional: "Email professionale",
      password: "Password",
      passwordMinChars: "Minimo 6 caratteri",
      loginButton: "Accedi",
      createAccount: "Crea un account",
      joinUs: "Unisciti a Opora Vie",
      joinPlatform: "Unisciti alla piattaforma in meno di un minuto.",
      iAm: "Sono",
      client: "Cliente",
      clientDesc: "Cerco un professionista",
      practitioner: "Professionista",
      practitionerDesc: "Offro i miei servizi",
      iAmClient: "Sono un cliente",
      iAmPractitioner: "Sono un professionista",
      firstName: "Nome",
      lastName: "Cognome",
      phone: "Telefono",
      phoneOptional: "Telefono (opzionale)",
      createMyAccount: "Crea il mio account",
      identityVerification: "Verifica dell'identità",
      verificationExplanation: "Inserisci il tuo nome e la tua email professionale. Ti invieremo un codice di 8 caratteri per convalidare la tua registrazione (valido 7 giorni).",
      sendMyCode: "Invia il mio codice",
      codeReceived: "Codice inviato!",
      checkEmail: "Un codice è stato inviato al tuo indirizzo email. Controlla anche la cartella spam.",
      accessCode: "Codice di accesso",
      verifyCode: "Verifica codice",
      resendCode: "← Rinvia un codice",
      codeVerifiedSuccess: "Codice verificato con successo!",
      createYourPassword: "Ora crea la tua password.",
      alreadyHaveAccount: "Hai già un account?",
      loginLink: "Accedi",
      gdprCompliant: "Conforme al GDPR",
      securePayments: "Pagamenti sicuri via Stripe",
      dataProtection: "Protezione dei dati",
      practitionerSignupTitle: "Registrazione Professionista",
      practitionerSignupSubtitle: "Crea il tuo account per iniziare a ricevere clienti",
      joinOpora: "Unisciti a Opora Vie",
      joinOporaSubtitle: "Sviluppa la tua attività e connettiti con clienti che cercano i tuoi servizi.",
      benefit1Title: "Maggiore visibilità",
      benefit1Desc: "Fatti trovare dai clienti nella tua zona",
      benefit2Title: "Gestione semplificata",
      benefit2Desc: "Gestisci facilmente appuntamenti e disponibilità",
      benefit3Title: "Consulti online",
      benefit3Desc: "Offri sessioni in videoconferenza",
      benefit4Title: "Pagamento sicuro",
      benefit4Desc: "Ricevi pagamenti online tramite Stripe",
      createPractitionerAccount: "Crea il mio account professionista",
      creatingAccount: "Creazione in corso...",
      alreadyRegistered: "Già registrato?"
    },
    booking: {
      bookWith: "Prenota con",
      chooseDate: "Scegli una data",
      chooseTime: "Scegli un orario",
      noSlotAvailable: "Nessuno slot disponibile per questa data",
      consultationType: "Tipo di consulto",
      inOffice: "In studio",
      onSite: "In loco",
      videoCall: "Videochiamata",
      remote: "A distanza",
      notes: "Note (opzionale)",
      notesPlaceholder: "Descrivi brevemente il motivo della tua consulenza...",
      confirmAppointment: "Conferma appuntamento",
      bookingInProgress: "Prenotazione in corso...",
      summary: "Riepilogo",
      date: "Data",
      time: "Ora",
      type: "Tipo",
      duration: "Durata",
      total: "Totale",
      paymentOnSite: "Pagamento in loco",
      payOnline: "Paga online",
      appointmentConfirmed: "Appuntamento confermato!",
      appointmentConfirmedDesc: "è stato registrato.",
      viewMyAppointments: "Vedi i miei appuntamenti",
      searchMorePractitioners: "Cerca altri professionisti",
      proceedToPayment: "Procedi al pagamento"
    },
    dashboard: {
      hello: "Ciao",
      manageAppointments: "Gestisci i tuoi appuntamenti e il tuo profilo",
      upcoming: "In arrivo",
      past: "Passati",
      cancelled: "Annullati",
      noUpcoming: "Nessun appuntamento in arrivo",
      findPractitioner: "Trova un professionista e prenota la tua prima consulenza",
      searchPractitioner: "Cerca un professionista",
      noPast: "Nessun appuntamento passato",
      pastWillAppear: "Le tue consulenze passate appariranno qui",
      noCancelled: "Nessun appuntamento annullato",
      cancelledWillAppear: "Le tue cancellazioni appariranno qui",
      viewProfile: "Vedi profilo",
      cancel: "Annulla",
      myProfile: "Il mio profilo",
      save: "Salva",
      saving: "Salvataggio...",
      joinVideoCall: "Partecipa alla videochiamata"
    },
    practitionerDashboard: {
      manageAppointmentsAndAvailability: "Gestisci i tuoi appuntamenti e disponibilità",
      editProfile: "Modifica il mio profilo",
      totalAppointments: "Totale appuntamenti",
      pending: "In attesa",
      confirmed: "Confermati",
      completed: "Completati",
      history: "Cronologia",
      noUpcoming: "Nessun appuntamento in arrivo",
      upcomingWillAppear: "I tuoi prossimi appuntamenti appariranno qui",
      noHistory: "Nessuna cronologia",
      pastWillAppear: "Le tue consulenze passate appariranno qui",
      confirm: "Conferma",
      refuse: "Rifiuta",
      markComplete: "Segna come completato",
      statistics: "Statistiche",
      noData: "Nessun dato disponibile",
      quickActions: "Azioni rapide",
      viewPublicPage: "Vedi la mia pagina pubblica",
      googleCalendar: "Google Calendar",
      connected: "Connesso - i tuoi appuntamenti sono sincronizzati",
      syncDescription: "Sincronizza automaticamente i tuoi appuntamenti con Google Calendar",
      connectGoogleCalendar: "Connetti Google Calendar",
      notConfigured: "Google Calendar non configurato su questo server"
    },
    about: {
      title: "Chi siamo - Opora Vie",
      subtitle: "La tua piattaforma per connetterti con professionisti del benessere",
      missionTitle: "La nostra missione",
      missionText: "Opora Vie è stato creato per facilitare l'accesso alla medicina naturale e al benessere. La nostra piattaforma mette in contatto le persone in cerca di miglior salute con professionisti qualificati a tutte le ore nella loro regione e paese a livello mondiale.",
      valuesTitle: "I nostri valori",
      value1Title: "Accessibilità",
      value1Desc: "Rendere la medicina naturale accessibile a tutti, in tutta la Francia e a livello internazionale.",
      value2Title: "Qualità",
      value2Desc: "Selezionare professionisti qualificati e certificati nel loro campo di competenza.",
      value3Title: "Fiducia",
      value3Desc: "Creare un ambiente di fiducia tra professionisti e pazienti.",
      locationTitle: "La nostra sede",
      locationSubtitle: "Con sede negli Yvelines (78), serviamo tutta la Francia e a livello internazionale",
      addressTitle: "Indirizzo",
      addressPlaceholder: "Indirizzo da definire",
      yvelinesDesc: "Dipartimento degli Yvelines (78) - Île-de-France",
      contactTitle: "Contattaci",
      contactEmail: "contact@apora.net"
    },
    specialties: {
      therapeute: "Terapeuta",
      naturopathe: "Naturopata",
      sophrologue: "Sofrologo",
      psychologue: "Psicologo",
      osteopathe: "Osteopata",
      hypnotherapeute: "Ipnoterapeuta",
      coach: "Coach",
      orthophoniste: "Logopedista"
    },
    common: {
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      back: "Indietro",
      next: "Avanti",
      minutes: "min",
      euro: "€"
    },
    payment: {
      paymentRequired: "Pagamento richiesto",
      paymentDescription: "Completa la prenotazione effettuando il pagamento",
      processing: "Elaborazione...",
      success: "Pagamento riuscito!",
      failed: "Pagamento fallito",
      cancelled: "Pagamento annullato",
      tryAgain: "Riprova"
    },
    practitionerSignup: {
      title: "Diventa Professionista",
      subtitle: "Unisciti alla comunità Opora Vie",
      backToHome: "Torna alla home",
      step1Title: "Passaggio 1: Richiesta di accesso",
      step1Desc: "Compila le tue informazioni. Ti invieremo un codice di accesso via email.",
      step2Title: "Passaggio 2: Verifica del codice",
      step2Desc: "Un codice di accesso è stato inviato alla tua email a",
      step3Title: "Passaggio 3: Contratto professionista",
      step3Desc: "Si prega di leggere e accettare i termini del contratto",
      step5Title: "Passaggio 5: Crea il tuo account",
      step5Desc: "Completa la registrazione creando le tue credenziali",
      firstName: "Nome",
      lastName: "Cognome",
      email: "Email",
      phone: "Telefono",
      password: "Password",
      passwordMin: "caratteri minimi",
      accessCode: "Codice di accesso",
      accessCodePlaceholder: "Inserisci il codice ricevuto via email",
      sendRequest: "Invia la mia richiesta",
      verifyCode: "Verifica codice",
      noCodeReceived: "Non hai ricevuto un codice?",
      resendRequest: "Reinvia richiesta",
      downloadContract: "Scarica contratto (PDF)",
      acceptTerms: "Ho letto e accetto i termini e le condizioni generali del contratto di accesso professionista. Capisco che una quota di registrazione di",
      willBeCharged: "sarà addebitata.",
      acceptAndPay: "Accetta e paga",
      createAccount: "Crea il mio account professionista",
      paymentReceived: "Pagamento ricevuto - Contratto accettato",
      alreadyAccount: "Hai già un account?",
      login: "Accedi",
      requestSent: "Richiesta inviata! Riceverai un codice via email.",
      codeVerified: "Codice verificato! Si prega di leggere e accettare il contratto.",
      paymentSuccess: "Pagamento riuscito! Ora crea il tuo account.",
      accountCreated: "Account professionista creato con successo!",
      mustAcceptTerms: "Devi accettare i termini del contratto",
      passwordTooShort: "La password deve essere di almeno 16 caratteri",
      sending: "Invio...",
      verifying: "Verifica...",
      redirectingPayment: "Reindirizzamento al pagamento...",
      creating: "Creazione..."
    }
  },
  ru: {
    nav: {
      findPractitioner: "Найти специалиста",
      login: "Вход",
      register: "Регистрация",
      becomePractitioner: "Стать специалистом",
      mySpace: "Мой кабинет",
      myPractitionerProfile: "Мой профиль специалиста",
      logout: "Выйти",
      about: "О нас",
      resources: "Ресурсы",
      practicalInfo: "Практическая информация",
      resourcesGuides: "Руководства & Советы",
      blog: "Блог / Новости"
    },
    landing: {
      badge: "Первый мировой портал для специалистов по натуральной медицине из Восточной Европы",
      title: "Найдите своего специалиста по благополучию",
      titleHighlight: "в любой точке мира",
      subtitle: "Вы покинули свою страну? Живёте далеко от семьи? Вы в стрессе, переживаете трудный период? Мы - линия поддержки. Наши терапевты, натуропаты, софрологи и психологи готовы выслушать и поддержать вас. Будь вы в Европе или где-либо ещё в мире - вы больше не одиноки.",
      searchSpecialty: "Специальность",
      searchSpecialtyPlaceholder: "Выберите специальность",
      searchCity: "Город",
      searchCityPlaceholder: "Париж, Лион, Марсель...",
      searchButton: "Искать",
      easyBooking: "Легкая запись",
      easyBookingDesc: "24/7",
      specialtiesTitle: "Наши специальности",
      specialtiesSubtitle: "Квалифицированные специалисты, которые понимают вашу культуру и говорят на вашем языке",
      featuredTitle: "Рекомендуемые специалисты",
      featuredSubtitle: "Просмотрите профили наших специалистов и запишитесь на прием",
      viewAll: "Все специалисты",
      perConsultation: "/ консультация",
      whyChooseTitle: "Почему выбирают нас?",
      whyChooseSubtitle: "Платформа, объединяющая сообщества из Восточной Европы",
      feature1Title: "Поддержка и выслушивание",
      feature1Desc: "Разлука с семьёй, адаптация к новой стране, тревога, личные или профессиональные проблемы - наши специалисты готовы выслушать",
      feature2Title: "Специалисты вашей культуры",
      feature2Desc: "Найдите специалистов, которые понимают ваш путь, говорят на вашем языке и знают ваши традиции",
      feature3Title: "Доступны везде",
      feature3Desc: "В кабинете или по видеосвязи, наши специалисты поддержат вас, где бы вы ни находились",
      ctaTitle: "Вы специалист?",
      ctaSubtitle: "Присоединяйтесь к нашей сети специалистов из Восточной Европы. Помогите своим соотечественникам-экспатриантам по всему миру.",
      ctaButton: "Создать профиль специалиста",
      testimonialTitle: "Что говорят наши пользователи",
      testimonialSubtitle: "Отзывы людей, которые нашли поддержку благодаря нашим специалистам",
      allRights: "Все права защищены."
    },
    testimonials: [
      {
        name: "Мари Дюпон",
        location: "Париж",
        text: "Благодаря Opora Vie я нашла отличного натуропата рядом со мной. Запись проста и быстра!",
        rating: 5
      },
      {
        name: "Жан-Пьер Мартен",
        location: "Лион",
        text: "Отличный сервис! Мой софролог очень помогает мне справляться со стрессом. Рекомендую эту платформу всем.",
        rating: 5
      },
      {
        name: "Софи Бернар",
        location: "Марсель",
        text: "Наконец-то платформа, которая объединяет всех специалистов по натуральной медицине. Очень удобно для сравнения и выбора.",
        rating: 5
      }
    ],
    search: {
      title: "Найти специалиста",
      practitionersAvailable: "специалист(ов) доступно",
      filters: "Фильтры",
      clear: "Очистить",
      specialty: "Специальность",
      allSpecialties: "Все специальности",
      country: "Страна",
      allCountries: "Все страны",
      region: "Регион",
      allRegions: "Все регионы",
      department: "Департамент",
      allDepartments: "Все департаменты",
      city: "Город",
      cityPlaceholder: "Найти город",
      consultationType: "Тип консультации",
      allTypes: "Все типы",
      cabinet: "В кабинете",
      video: "Видеозвонок",
      applyFilters: "Применить фильтры",
      noPractitionerFound: "Специалист не найден",
      featuredPractitioners: "Рекомендуемые специалисты",
      tryDifferentCriteria: "Попробуйте изменить критерии поиска",
      clearFilters: "Очистить фильтры",
      listView: "Список",
      mapView: "Карта",
      noLocationAvailable: "Нет специалистов с доступным местоположением"
    },
    auth: {
      welcome: "Добро пожаловать в Opora Vie",
      welcomeSubtitle: "Найдите идеального специалиста для вашего здоровья или развивайте свою практику.",
      backToHome: "На главную",
      login: "Вход",
      register: "Регистрация",
      welcomeBack: "С возвращением!",
      connectToAccount: "Войдите в свой аккаунт",
      email: "Email",
      emailProfessional: "Рабочий email",
      password: "Пароль",
      passwordMinChars: "Минимум 6 символов",
      loginButton: "Войти",
      createAccount: "Создать аккаунт",
      joinUs: "Присоединиться к Opora Vie",
      joinPlatform: "Присоединяйтесь к платформе менее чем за минуту.",
      iAm: "Я",
      client: "Клиент",
      clientDesc: "Ищу специалиста",
      practitioner: "Специалист",
      practitionerDesc: "Предлагаю свои услуги",
      iAmClient: "Я клиент",
      iAmPractitioner: "Я специалист",
      firstName: "Имя",
      lastName: "Фамилия",
      phone: "Телефон",
      phoneOptional: "Телефон (необязательно)",
      createMyAccount: "Создать мой аккаунт",
      identityVerification: "Подтверждение личности",
      verificationExplanation: "Введите ваше имя и рабочий email. Мы отправим вам 8-значный код для подтверждения регистрации (действителен 7 дней).",
      sendMyCode: "Отправить мой код",
      codeReceived: "Код отправлен!",
      checkEmail: "Код отправлен на ваш email. Проверьте также папку спам.",
      accessCode: "Код доступа",
      verifyCode: "Проверить код",
      resendCode: "← Отправить код повторно",
      codeVerifiedSuccess: "Код успешно подтвержден!",
      createYourPassword: "Теперь создайте пароль.",
      alreadyHaveAccount: "Уже есть аккаунт?",
      loginLink: "Войти",
      gdprCompliant: "Соответствует GDPR",
      securePayments: "Безопасные платежи через Stripe",
      dataProtection: "Защита данных",
      practitionerSignupTitle: "Регистрация специалиста",
      practitionerSignupSubtitle: "Создайте аккаунт, чтобы начать принимать клиентов",
      joinOpora: "Присоединяйтесь к Opora Vie",
      joinOporaSubtitle: "Развивайте свою практику и связывайтесь с клиентами, которые ищут ваши услуги.",
      benefit1Title: "Повышенная видимость",
      benefit1Desc: "Будьте найдены клиентами в вашем регионе",
      benefit2Title: "Упрощенное управление",
      benefit2Desc: "Легко управляйте записями и расписанием",
      benefit3Title: "Онлайн консультации",
      benefit3Desc: "Проводите сеансы по видеосвязи",
      benefit4Title: "Безопасная оплата",
      benefit4Desc: "Получайте онлайн-платежи через Stripe",
      createPractitionerAccount: "Создать аккаунт специалиста",
      creatingAccount: "Создание аккаунта...",
      alreadyRegistered: "Уже зарегистрированы?"
    },
    booking: {
      bookWith: "Записаться к",
      chooseDate: "Выберите дату",
      chooseTime: "Выберите время",
      noSlotAvailable: "Нет доступных слотов на эту дату",
      consultationType: "Тип консультации",
      inOffice: "В кабинете",
      onSite: "На месте",
      videoCall: "Видеозвонок",
      remote: "Удаленно",
      notes: "Заметки (необязательно)",
      notesPlaceholder: "Кратко опишите причину консультации...",
      confirmAppointment: "Подтвердить запись",
      bookingInProgress: "Запись выполняется...",
      summary: "Итого",
      date: "Дата",
      time: "Время",
      type: "Тип",
      duration: "Длительность",
      total: "Итого",
      paymentOnSite: "Оплата на месте",
      payOnline: "Оплатить онлайн",
      appointmentConfirmed: "Запись подтверждена!",
      appointmentConfirmedDesc: "была зарегистрирована.",
      viewMyAppointments: "Мои записи",
      searchMorePractitioners: "Найти других специалистов",
      proceedToPayment: "Перейти к оплате"
    },
    dashboard: {
      hello: "Здравствуйте",
      manageAppointments: "Управляйте записями и профилем",
      upcoming: "Предстоящие",
      past: "Прошедшие",
      cancelled: "Отмененные",
      noUpcoming: "Нет предстоящих записей",
      findPractitioner: "Найдите специалиста и запишитесь на первую консультацию",
      searchPractitioner: "Найти специалиста",
      noPast: "Нет прошедших записей",
      pastWillAppear: "Ваши прошлые консультации появятся здесь",
      noCancelled: "Нет отмененных записей",
      cancelledWillAppear: "Ваши отмены появятся здесь",
      viewProfile: "Профиль",
      cancel: "Отменить",
      myProfile: "Мой профиль",
      save: "Сохранить",
      saving: "Сохранение...",
      joinVideoCall: "Присоединиться к видеоконсультации"
    },
    practitionerDashboard: {
      manageAppointmentsAndAvailability: "Управляйте записями и расписанием",
      editProfile: "Редактировать профиль",
      totalAppointments: "Всего записей",
      pending: "Ожидают",
      confirmed: "Подтверждены",
      completed: "Завершены",
      history: "История",
      noUpcoming: "Нет предстоящих записей",
      upcomingWillAppear: "Ваши предстоящие записи появятся здесь",
      noHistory: "Нет истории",
      pastWillAppear: "Ваши прошлые консультации появятся здесь",
      confirm: "Подтвердить",
      refuse: "Отклонить",
      markComplete: "Отметить как завершено",
      statistics: "Статистика",
      noData: "Нет данных",
      quickActions: "Быстрые действия",
      viewPublicPage: "Моя публичная страница",
      googleCalendar: "Google Календарь",
      connected: "Подключен - записи синхронизированы",
      syncDescription: "Автоматически синхронизируйте записи с Google Календарем",
      connectGoogleCalendar: "Подключить Google Календарь",
      notConfigured: "Google Календарь не настроен на этом сервере"
    },
    about: {
      title: "О Opora Vie",
      subtitle: "Ваша платформа для связи со специалистами по здоровью",
      missionTitle: "Наша миссия",
      missionText: "Opora Vie был создан для облегчения доступа к натуральной медицине и благополучию. Наша платформа соединяет людей, стремящихся к лучшему здоровью, с квалифицированными специалистами круглосуточно в их регионе и стране по всему миру.",
      valuesTitle: "Наши ценности",
      value1Title: "Доступность",
      value1Desc: "Сделать натуральную медицину доступной для всех, по всей Франции и за рубежом.",
      value2Title: "Качество",
      value2Desc: "Отбор квалифицированных и сертифицированных специалистов в своей области.",
      value3Title: "Доверие",
      value3Desc: "Создание атмосферы доверия между специалистами и их пациентами.",
      locationTitle: "Наше местоположение",
      locationSubtitle: "Базируясь в Ивелин (78), мы обслуживаем всю Францию и международных клиентов",
      addressTitle: "Адрес",
      addressPlaceholder: "Адрес будет определен",
      yvelinesDesc: "Департамент Ивелин (78) - Иль-де-Франс",
      contactTitle: "Связаться с нами",
      contactEmail: "contact@apora.net"
    },
    specialties: {
      therapeute: "Терапевт",
      naturopathe: "Натуропат",
      sophrologue: "Софролог",
      psychologue: "Психолог",
      osteopathe: "Остеопат",
      hypnotherapeute: "Гипнотерапевт",
      coach: "Коуч",
      orthophoniste: "Логопед"
    },
    common: {
      loading: "Загрузка...",
      error: "Ошибка",
      success: "Успех",
      back: "Назад",
      next: "Далее",
      minutes: "мин",
      euro: "€"
    },
    payment: {
      paymentRequired: "Требуется оплата",
      paymentDescription: "Завершите бронирование, произведя оплату",
      processing: "Обработка...",
      success: "Оплата прошла успешно!",
      failed: "Ошибка оплаты",
      cancelled: "Оплата отменена",
      tryAgain: "Повторить"
    },
    practitionerSignup: {
      title: "Стать специалистом",
      subtitle: "Присоединяйтесь к сообществу Opora Vie",
      backToHome: "Вернуться на главную",
      step1Title: "Шаг 1: Запрос доступа",
      step1Desc: "Заполните вашу информацию. Мы отправим вам код доступа по email.",
      step2Title: "Шаг 2: Проверка кода",
      step2Desc: "Код доступа был отправлен на вашу почту",
      step3Title: "Шаг 3: Контракт специалиста",
      step3Desc: "Пожалуйста, прочитайте и примите условия контракта",
      step5Title: "Шаг 5: Создайте аккаунт",
      step5Desc: "Завершите регистрацию, создав учетные данные",
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Email",
      phone: "Телефон",
      password: "Пароль",
      passwordMin: "символов минимум",
      accessCode: "Код доступа",
      accessCodePlaceholder: "Введите код, полученный по email",
      sendRequest: "Отправить запрос",
      verifyCode: "Проверить код",
      noCodeReceived: "Не получили код?",
      resendRequest: "Отправить повторно",
      downloadContract: "Скачать контракт (PDF)",
      acceptTerms: "Я прочитал(а) и принимаю общие условия контракта доступа специалиста. Я понимаю, что регистрационный взнос в размере",
      willBeCharged: "будет взиматься.",
      acceptAndPay: "Принять и оплатить",
      createAccount: "Создать аккаунт специалиста",
      paymentReceived: "Оплата получена - Контракт принят",
      alreadyAccount: "Уже есть аккаунт?",
      login: "Войти",
      requestSent: "Запрос отправлен! Вы получите код по email.",
      codeVerified: "Код подтвержден! Пожалуйста, прочитайте и примите контракт.",
      paymentSuccess: "Оплата прошла успешно! Теперь создайте аккаунт.",
      accountCreated: "Аккаунт специалиста успешно создан!",
      mustAcceptTerms: "Вы должны принять условия контракта",
      passwordTooShort: "Пароль должен содержать минимум 16 символов",
      sending: "Отправка...",
      verifying: "Проверка...",
      redirectingPayment: "Перенаправление на оплату...",
      creating: "Создание..."
    }
  },
  ro: {
    nav: {
      findPractitioner: "Găsește un specialist",
      login: "Conectare",
      register: "Înregistrare",
      becomePractitioner: "Devino Specialist",
      mySpace: "Spațiul meu",
      myPractitionerProfile: "Profilul meu de specialist",
      logout: "Deconectare",
      about: "Despre noi",
      resources: "Resurse",
      practicalInfo: "Informații practice",
      resourcesGuides: "Ghiduri & Sfaturi",
      blog: "Blog / Știri"
    },
    landing: {
      badge: "Primul portal mondial pentru specialiști în medicină naturală din Europa de Est",
      title: "Găsește-ți specialistul în bunăstare",
      titleHighlight: "oriunde în lume",
      subtitle: "Ai părăsit țara ta? Trăiești departe de familie? Ești în suferință, treci printr-o perioadă dificilă? Suntem o linie de ascultare. Terapeuții, naturopații, sofrologii și psihologii noștri sunt aici să te asculte și să te însoțească. Fie că ești în Europa sau oriunde altundeva în lume, nu mai ești singur.",
      searchSpecialty: "Specialitate",
      searchSpecialtyPlaceholder: "Alege o specialitate",
      searchCity: "Oraș",
      searchCityPlaceholder: "Paris, Lyon, Marsilia...",
      searchButton: "Caută",
      easyBooking: "Programare ușoară",
      easyBookingDesc: "24/7",
      specialtiesTitle: "Specialitățile noastre",
      specialtiesSubtitle: "Specialiști calificați care înțeleg cultura ta și vorbesc limba ta",
      featuredTitle: "Specialiști recomandați",
      featuredSubtitle: "Consultă profilurile specialiștilor noștri și programează-te",
      viewAll: "Vezi toți specialiștii",
      perConsultation: "/ consultație",
      whyChooseTitle: "De ce să ne alegi?",
      whyChooseSubtitle: "O platformă care apropie comunitățile din Est",
      feature1Title: "Suport și ascultare",
      feature1Desc: "Separare de familie, adaptare la o nouă țară, anxietate, probleme personale sau profesionale - specialiștii noștri sunt aici să te asculte",
      feature2Title: "Specialiști din cultura ta",
      feature2Desc: "Găsește specialiști care înțeleg parcursul tău, vorbesc limba ta și cunosc tradițiile tale",
      feature3Title: "Disponibili peste tot",
      feature3Desc: "La cabinet sau prin video, specialiștii noștri te susțin oriunde te-ai afla în lume",
      ctaTitle: "Ești specialist?",
      ctaSubtitle: "Alătură-te rețelei noastre de specialiști din Europa de Est. Ajută-ți compatrioții expatriați din întreaga lume.",
      ctaButton: "Creează-mi profilul de specialist",
      testimonialTitle: "Ce spun utilizatorii noștri",
      testimonialSubtitle: "Descoperă mărturiile persoanelor care au găsit sprijin prin specialiștii noștri",
      allRights: "Toate drepturile rezervate."
    },
    testimonials: [
      {
        name: "Marie Dupont",
        location: "Paris",
        text: "Datorită Opora Vie, am găsit un naturopat excepțional aproape de mine. Programarea este simplă și rapidă!",
        rating: 5
      },
      {
        name: "Jean-Pierre Martin",
        location: "Lyon",
        text: "Serviciu excelent! Sofrologul meu mă ajută foarte mult să gestionez stresul. Recomand această platformă tuturor.",
        rating: 5
      },
      {
        name: "Sophie Bernard",
        location: "Marsilia",
        text: "În sfârșit o platformă care reunește toți specialiștii în medicină naturală. Foarte practic pentru a compara și alege.",
        rating: 5
      }
    ],
    search: {
      title: "Găsește un specialist",
      practitionersAvailable: "specialist(i) disponibil(i)",
      filters: "Filtre",
      clear: "Șterge",
      specialty: "Specialitate",
      allSpecialties: "Toate specialitățile",
      country: "Țară",
      allCountries: "Toate țările",
      region: "Regiune",
      allRegions: "Toate regiunile",
      department: "Departament",
      allDepartments: "Toate departamentele",
      city: "Oraș",
      cityPlaceholder: "Caută un oraș",
      consultationType: "Tip de consultație",
      allTypes: "Toate tipurile",
      cabinet: "La cabinet",
      video: "Video",
      applyFilters: "Aplică filtrele",
      noPractitionerFound: "Niciun specialist găsit",
      featuredPractitioners: "Specialiști recomandați",
      tryDifferentCriteria: "Încearcă să modifici criteriile de căutare",
      clearFilters: "Șterge filtrele",
      listView: "Listă",
      mapView: "Hartă",
      noLocationAvailable: "Niciun specialist cu locație disponibilă"
    },
    auth: {
      welcome: "Bine ai venit la Opora Vie",
      welcomeSubtitle: "Găsește specialistul ideal pentru bunăstarea ta sau dezvoltă-ți activitatea.",
      backToHome: "Înapoi acasă",
      login: "Conectare",
      register: "Înregistrare",
      welcomeBack: "Bine ai revenit!",
      connectToAccount: "Conectează-te la contul tău",
      email: "Email",
      emailProfessional: "Email profesional",
      password: "Parolă",
      passwordMinChars: "Minim 6 caractere",
      loginButton: "Conectare",
      createAccount: "Creează un cont",
      joinUs: "Alătură-te Opora Vie",
      joinPlatform: "Alătură-te platformei în mai puțin de un minut.",
      iAm: "Sunt",
      client: "Client",
      clientDesc: "Caut un specialist",
      practitioner: "Specialist",
      practitionerDesc: "Ofer serviciile mele",
      iAmClient: "Sunt client",
      iAmPractitioner: "Sunt specialist",
      firstName: "Prenume",
      lastName: "Nume",
      phone: "Telefon",
      phoneOptional: "Telefon (opțional)",
      createMyAccount: "Creează contul meu",
      identityVerification: "Verificarea identității",
      verificationExplanation: "Introdu numele și emailul profesional. Îți vom trimite un cod de 8 caractere pentru a valida înregistrarea (valabil 7 zile).",
      sendMyCode: "Trimite codul meu",
      codeReceived: "Cod trimis!",
      checkEmail: "Un cod a fost trimis la adresa ta de email. Verifică și folderul spam.",
      accessCode: "Cod de acces",
      verifyCode: "Verifică codul",
      resendCode: "← Retrimite un cod",
      codeVerifiedSuccess: "Cod verificat cu succes!",
      createYourPassword: "Acum creează-ți parola.",
      alreadyHaveAccount: "Ai deja un cont?",
      loginLink: "Conectare",
      gdprCompliant: "Conform GDPR",
      securePayments: "Plăți securizate prin Stripe",
      dataProtection: "Protecția datelor",
      practitionerSignupTitle: "Înregistrare Specialist",
      practitionerSignupSubtitle: "Creează-ți contul pentru a începe să primești clienți",
      joinOpora: "Alătură-te Opora Vie",
      joinOporaSubtitle: "Dezvoltă-ți activitatea și conectează-te cu clienții care îți caută serviciile.",
      benefit1Title: "Vizibilitate crescută",
      benefit1Desc: "Fii găsit de clienți din zona ta",
      benefit2Title: "Gestionare simplificată",
      benefit2Desc: "Gestionează-ți ușor programările și disponibilitatea",
      benefit3Title: "Consultații online",
      benefit3Desc: "Oferă ședințe prin videoconferință",
      benefit4Title: "Plată securizată",
      benefit4Desc: "Primește plăți online prin Stripe",
      createPractitionerAccount: "Creează contul meu de specialist",
      creatingAccount: "Se creează contul...",
      alreadyRegistered: "Deja înregistrat?"
    },
    booking: {
      bookWith: "Programează-te la",
      chooseDate: "Alege o dată",
      chooseTime: "Alege o oră",
      noSlotAvailable: "Niciun slot disponibil pentru această dată",
      consultationType: "Tip de consultație",
      inOffice: "La cabinet",
      onSite: "La fața locului",
      videoCall: "Video",
      remote: "La distanță",
      notes: "Note (opțional)",
      notesPlaceholder: "Descrie pe scurt motivul consultației...",
      confirmAppointment: "Confirmă programarea",
      bookingInProgress: "Programare în curs...",
      summary: "Rezumat",
      date: "Data",
      time: "Ora",
      type: "Tip",
      duration: "Durată",
      total: "Total",
      paymentOnSite: "Plată la fața locului",
      payOnline: "Plătește online",
      appointmentConfirmed: "Programare confirmată!",
      appointmentConfirmedDesc: "a fost înregistrată.",
      viewMyAppointments: "Vezi programările mele",
      searchMorePractitioners: "Caută alți specialiști",
      proceedToPayment: "Continuă spre plată"
    },
    dashboard: {
      hello: "Bună",
      manageAppointments: "Gestionează-ți programările și profilul",
      upcoming: "Viitoare",
      past: "Trecute",
      cancelled: "Anulate",
      noUpcoming: "Nicio programare viitoare",
      findPractitioner: "Găsește un specialist și programează prima ta consultație",
      searchPractitioner: "Caută un specialist",
      noPast: "Nicio programare trecută",
      pastWillAppear: "Consultațiile tale trecute vor apărea aici",
      noCancelled: "Nicio programare anulată",
      cancelledWillAppear: "Anulările tale vor apărea aici",
      viewProfile: "Vezi profilul",
      cancel: "Anulează",
      myProfile: "Profilul meu",
      save: "Salvează",
      saving: "Se salvează...",
      joinVideoCall: "Alătură-te consultației video"
    },
    practitionerDashboard: {
      manageAppointmentsAndAvailability: "Gestionează-ți programările și disponibilitatea",
      editProfile: "Editează profilul meu",
      totalAppointments: "Total programări",
      pending: "În așteptare",
      confirmed: "Confirmate",
      completed: "Finalizate",
      history: "Istoric",
      noUpcoming: "Nicio programare viitoare",
      upcomingWillAppear: "Programările tale viitoare vor apărea aici",
      noHistory: "Niciun istoric",
      pastWillAppear: "Consultațiile tale trecute vor apărea aici",
      confirm: "Confirmă",
      refuse: "Refuză",
      markComplete: "Marchează ca finalizat",
      statistics: "Statistici",
      noData: "Nicio dată disponibilă",
      quickActions: "Acțiuni rapide",
      viewPublicPage: "Vezi pagina mea publică",
      googleCalendar: "Google Calendar",
      connected: "Conectat - programările tale sunt sincronizate",
      syncDescription: "Sincronizează automat programările cu Google Calendar",
      connectGoogleCalendar: "Conectează Google Calendar",
      notConfigured: "Google Calendar nu este configurat pe acest server"
    },
    about: {
      title: "Despre Opora Vie",
      subtitle: "Platforma ta pentru conectarea cu specialiști în bunăstare",
      missionTitle: "Misiunea noastră",
      missionText: "Opora Vie a fost creat pentru a facilita accesul la medicina naturală și bunăstare. Platforma noastră conectează persoanele care caută o sănătate mai bună cu specialiști calificați non-stop în regiunea și țara lor la nivel mondial.",
      valuesTitle: "Valorile noastre",
      value1Title: "Accesibilitate",
      value1Desc: "Facem medicina naturală accesibilă tuturor, în toată Franța și internațional.",
      value2Title: "Calitate",
      value2Desc: "Selectăm specialiști calificați și certificați în domeniul lor de expertiză.",
      value3Title: "Încredere",
      value3Desc: "Creăm un mediu de încredere între specialiști și pacienții lor.",
      locationTitle: "Locația noastră",
      locationSubtitle: "Cu sediul în Yvelines (78), deservim toată Franța și internațional",
      addressTitle: "Adresă",
      addressPlaceholder: "Adresă de definit",
      yvelinesDesc: "Departamentul Yvelines (78) - Île-de-France",
      contactTitle: "Contactează-ne",
      contactEmail: "contact@apora.net"
    },
    specialties: {
      therapeute: "Terapeut",
      naturopathe: "Naturopat",
      sophrologue: "Sofrolog",
      psychologue: "Psiholog",
      osteopathe: "Osteopat",
      hypnotherapeute: "Hipnoterapeut",
      coach: "Coach",
      orthophoniste: "Logoped"
    },
    common: {
      loading: "Se încarcă...",
      error: "Eroare",
      success: "Succes",
      back: "Înapoi",
      next: "Următor",
      minutes: "min",
      euro: "€"
    },
    payment: {
      paymentRequired: "Plată necesară",
      paymentDescription: "Finalizează-ți rezervarea efectuând plata",
      processing: "Se procesează...",
      success: "Plată reușită!",
      failed: "Plată eșuată",
      cancelled: "Plată anulată",
      tryAgain: "Încearcă din nou"
    },
    practitionerSignup: {
      title: "Devino Specialist",
      subtitle: "Alătură-te comunității Opora Vie",
      backToHome: "Înapoi la pagina principală",
      step1Title: "Pasul 1: Cerere de acces",
      step1Desc: "Completează informațiile tale. Îți vom trimite un cod de acces prin email.",
      step2Title: "Pasul 2: Verificarea codului",
      step2Desc: "Un cod de acces a fost trimis la emailul tău la",
      step3Title: "Pasul 3: Contractul de specialist",
      step3Desc: "Te rugăm să citești și să accepți termenii contractului",
      step5Title: "Pasul 5: Creează-ți contul",
      step5Desc: "Finalizează înregistrarea creându-ți datele de autentificare",
      firstName: "Prenume",
      lastName: "Nume",
      email: "Email",
      phone: "Telefon",
      password: "Parolă",
      passwordMin: "caractere minimum",
      accessCode: "Cod de acces",
      accessCodePlaceholder: "Introdu codul primit prin email",
      sendRequest: "Trimite cererea mea",
      verifyCode: "Verifică codul",
      noCodeReceived: "Nu ai primit un cod?",
      resendRequest: "Retrimite cererea",
      downloadContract: "Descarcă contractul (PDF)",
      acceptTerms: "Am citit și accept termenii și condițiile generale ale contractului de acces specialist. Înțeleg că o taxă de înregistrare de",
      willBeCharged: "va fi percepută.",
      acceptAndPay: "Acceptă și plătește",
      createAccount: "Creează contul meu de specialist",
      paymentReceived: "Plată primită - Contract acceptat",
      alreadyAccount: "Ai deja un cont?",
      login: "Conectează-te",
      requestSent: "Cerere trimisă! Vei primi un cod prin email.",
      codeVerified: "Cod verificat! Te rugăm să citești și să accepți contractul.",
      paymentSuccess: "Plată reușită! Acum creează-ți contul.",
      accountCreated: "Cont de specialist creat cu succes!",
      mustAcceptTerms: "Trebuie să accepți termenii contractului",
      passwordTooShort: "Parola trebuie să aibă cel puțin 16 caractere",
      sending: "Se trimite...",
      verifying: "Se verifică...",
      redirectingPayment: "Redirecționare către plată...",
      creating: "Se creează..."
    }
  },
  
  // Ukrainian
  uk: {
    nav: {
      findPractitioner: "Знайти спеціаліста",
      login: "Вхід",
      register: "Реєстрація",
      becomePractitioner: "Стати спеціалістом",
      mySpace: "Мій простір",
      myPractitionerProfile: "Мій профіль спеціаліста",
      logout: "Вийти",
      about: "Про нас",
      resources: "Ресурси",
      practicalInfo: "Практична інформація",
      resourcesGuides: "Посібники & Поради",
      blog: "Блог / Новини"
    },
    landing: {
      badge: "Перший світовий портал для спеціалістів з натуральної медицини зі Східної Європи",
      title: "Знайдіть свого спеціаліста з благополуччя",
      titleHighlight: "будь-де у світі",
      subtitle: "Ви покинули свою країну? Живете далеко від сім'ї? Ви в стані стресу, переживаєте важкий період? Ми - лінія підтримки. Наші терапевти, натуропати, софрологи та психологи готові вас вислухати та підтримати. Чи ви в Європі чи будь-де у світі - ви більше не самотні.",
      searchSpecialty: "Спеціальність",
      searchSpecialtyPlaceholder: "Виберіть спеціальність",
      searchCity: "Місто",
      searchCityPlaceholder: "Париж, Ліон, Марсель...",
      searchButton: "Пошук",
      easyBooking: "Легке бронювання",
      easyBookingDesc: "24/7",
      specialtiesTitle: "Наші спеціальності",
      specialtiesSubtitle: "Кваліфіковані спеціалісти, які розуміють вашу культуру та говорять вашою мовою",
      featuredTitle: "Рекомендовані спеціалісти",
      featuredSubtitle: "Перегляньте профілі наших спеціалістів та запишіться на прийом",
      viewAll: "Переглянути всіх спеціалістів",
      perConsultation: "/ консультація",
      whyChooseTitle: "Чому обирають нас?",
      whyChooseSubtitle: "Платформа, яка об'єднує спільноти зі Східної Європи",
      feature1Title: "Підтримка та вислуховування",
      feature1Desc: "Розлука з сім'єю, адаптація до нової країни, тривога, особисті чи професійні проблеми - наші спеціалісти готові вислухати",
      feature2Title: "Спеціалісти з вашої культури",
      feature2Desc: "Знайдіть спеціалістів, які розуміють ваш шлях, говорять вашою мовою та знають ваші традиції",
      feature3Title: "Доступні скрізь",
      feature3Desc: "У кабінеті чи через відеозв'язок, наші спеціалісти підтримують вас, де б ви не були",
      ctaTitle: "Ви спеціаліст?",
      ctaSubtitle: "Приєднуйтесь до нашої мережі спеціалістів зі Східної Європи. Допоможіть своїм співвітчизникам-експатріантам по всьому світу.",
      ctaButton: "Створити профіль спеціаліста",
      testimonialTitle: "Що кажуть наші користувачі",
      testimonialSubtitle: "Відгуки людей, які знайшли підтримку завдяки нашим спеціалістам",
      allRights: "Усі права захищені."
    },
    search: {
      title: "Знайти спеціаліста",
      practitionersAvailable: "спеціалістів доступно",
      specialty: "Спеціальність",
      location: "Місце",
      searchButton: "Пошук",
      allSpecialties: "Усі спеціальності",
      chooseSpeacialty: "Виберіть спеціальність",
      filters: "Фільтри",
      results: "результатів",
      noResults: "Спеціалістів не знайдено",
      noResultsDesc: "Спробуйте змінити критерії пошуку",
      noPractitionerFound: "Спеціалістів не знайдено",
      featuredPractitioners: "Рекомендовані спеціалісти",
      tryDifferentCriteria: "Спробуйте змінити критерії пошуку",
      clearFilters: "Очистити фільтри",
      clear: "Очистити",
      applyFilters: "Застосувати фільтри",
      consultationType: "Тип консультації",
      allTypes: "Усі типи",
      cabinet: "У кабінеті",
      onSite: "У кабінеті",
      video: "Відеоконсультація",
      priceRange: "Діапазон цін",
      sortBy: "Сортувати за",
      relevance: "Релевантність",
      priceLowHigh: "Ціна: від низької до високої",
      priceHighLow: "Ціна: від високої до низької",
      country: "Країна",
      region: "Регіон",
      department: "Департамент",
      city: "Місто",
      cityPlaceholder: "Введіть місто",
      allCountries: "Усі країни",
      allRegions: "Усі регіони",
      allDepartments: "Усі департаменти",
      listView: "Список",
      mapView: "Карта",
      noLocationAvailable: "Немає спеціалістів з доступною локацією"
    },
    auth: {
      welcome: "Ласкаво просимо до Opora Vie",
      welcomeSubtitle: "Знайдіть ідеального спеціаліста для вашого здоров'я або розвивайте свою практику.",
      backToHome: "На головну",
      login: "Вхід",
      register: "Реєстрація",
      welcomeBack: "З поверненням!",
      connectToAccount: "Увійдіть до свого акаунту",
      email: "Email",
      emailProfessional: "Робоча email",
      password: "Пароль",
      passwordMinChars: "Мінімум 6 символів",
      loginButton: "Увійти",
      createAccount: "Створити акаунт",
      joinUs: "Приєднуйтесь до Opora Vie",
      joinPlatform: "Приєднуйтесь до платформи менш ніж за хвилину.",
      iAm: "Я",
      client: "Клієнт",
      clientDesc: "Шукаю спеціаліста",
      practitioner: "Спеціаліст",
      practitionerDesc: "Пропоную свої послуги",
      iAmClient: "Я клієнт",
      iAmPractitioner: "Я спеціаліст",
      firstName: "Ім'я",
      lastName: "Прізвище",
      phone: "Телефон",
      phoneOptional: "Телефон (необов'язково)",
      createMyAccount: "Створити мій акаунт",
      identityVerification: "Підтвердження особи",
      verificationExplanation: "Введіть ваше ім'я та робочу email. Ми надішлемо вам 8-значний код для підтвердження реєстрації (дійсний 7 днів).",
      sendMyCode: "Надіслати мій код",
      codeReceived: "Код надіслано!",
      checkEmail: "Код надіслано на вашу email. Перевірте також папку спам.",
      accessCode: "Код доступу",
      verifyCode: "Перевірити код",
      resendCode: "← Надіслати код повторно",
      codeVerifiedSuccess: "Код успішно підтверджено!",
      createYourPassword: "Тепер створіть пароль.",
      alreadyHaveAccount: "Вже є акаунт?",
      loginLink: "Увійти",
      gdprCompliant: "Відповідає GDPR",
      securePayments: "Безпечні платежі через Stripe",
      dataProtection: "Захист даних",
      practitionerSignupTitle: "Реєстрація спеціаліста",
      practitionerSignupSubtitle: "Створіть акаунт, щоб почати приймати клієнтів",
      joinOpora: "Приєднуйтесь до Opora Vie",
      joinOporaSubtitle: "Розвивайте свою практику та зв'язуйтесь з клієнтами, які шукають ваші послуги.",
      benefit1Title: "Підвищена видимість",
      benefit1Desc: "Будьте знайдені клієнтами у вашому регіоні",
      benefit2Title: "Спрощене управління",
      benefit2Desc: "Легко керуйте записами та розкладом",
      benefit3Title: "Онлайн консультації",
      benefit3Desc: "Проводьте сеанси через відеозв'язок",
      benefit4Title: "Безпечна оплата",
      benefit4Desc: "Отримуйте онлайн-платежі через Stripe",
      createPractitionerAccount: "Створити акаунт спеціаліста",
      creatingAccount: "Створення акаунту...",
      alreadyRegistered: "Вже зареєстровані?"
    },
    specialties: {
      therapeute: "Терапевт",
      naturopathe: "Натуропат",
      sophrologue: "Софролог",
      psychologue: "Психолог",
      osteopathe: "Остеопат",
      hypnotherapeute: "Гіпнотерапевт",
      coach: "Коуч",
      orthophoniste: "Логопед"
    },
    features: {
      title: "Наші спеціальності",
      subtitle: "Відкрийте для себе наших кваліфікованих спеціалістів"
    },
    practitioner: {
      viewProfile: "Переглянути профіль",
      bookAppointment: "Записатися",
      about: "Про",
      services: "Послуги",
      availability: "Доступність",
      contact: "Контакт",
      officeConsultation: "Консультація в кабінеті",
      videoConsultation: "Відеоконсультація",
      perSession: "за сеанс",
      yearsExperience: "років досвіду",
      diplomasCertifications: "Дипломи та сертифікати",
      spokenLanguages: "Мови"
    },
    testimonials: [
      {
        name: "Марія Дюпон",
        location: "Париж",
        text: "Завдяки Opora Vie я знайшла чудового натуропата поруч з домом. Записатися на прийом просто і швидко!",
        rating: 5
      },
      {
        name: "Жан-П'єр Мартен",
        location: "Ліон",
        text: "Відмінний сервіс! Мій софролог дуже допомагає мені справлятися зі стресом. Рекомендую цю платформу всім.",
        rating: 5
      },
      {
        name: "Софі Бернар",
        location: "Марсель",
        text: "Нарешті платформа, яка об'єднує всіх спеціалістів природної медицини. Дуже зручно порівнювати та вибирати.",
        rating: 5
      }
    ],
    testimonialsSection: {
      title: "Що кажуть наші користувачі",
      subtitle: "Відгуки задоволених клієнтів"
    },
    footer: {
      description: "Платформа для зв'язку спеціалістів з природного здоров'я та благополуччя з клієнтами.",
      navigation: "Навігація",
      legal: "Юридична інформація",
      privacyPolicy: "Політика конфіденційності",
      termsOfService: "Умови використання",
      copyright: "Opora Vie. Усі права захищені."
    },
    about: {
      title: "Про Opora Vie",
      subtitle: "Ваш шлях до благополуччя починається тут",
      missionTitle: "Наша місія",
      ourMission: "Наша місія",
      missionText: "Opora Vie було створено для полегшення доступу до натуральної медицини та благополуччя. Наша платформа з'єднує людей, які прагнуть кращого здоров'я, з кваліфікованими спеціалістами цілодобово в їхньому регіоні та країні по всьому світу.",
      ourValues: "Наші цінності",
      valuesTitle: "Наші цінності",
      value1Title: "Благополуччя",
      value1Desc: "Ми ставимо благополуччя наших користувачів у центр нашого підходу",
      value2Title: "Якість",
      value2Desc: "Ми відбираємо кваліфікованих і перевірених спеціалістів",
      value3Title: "Доступність",
      value3Desc: "Ми робимо природну медицину доступною для всіх",
      findUs: "Знайдіть нас",
      address: "Адреса буде визначена",
      locationTitle: "Наше розташування",
      locationSubtitle: "Базуючись в Івеліні (78), ми обслуговуємо всю Францію та світ",
      addressTitle: "Адреса",
      addressPlaceholder: "Адреса буде визначена",
      yvelinesDesc: "Департамент Івелін (78) - Іль-де-Франс",
      contactTitle: "Зв'яжіться з нами",
      contactEmail: "contact@apora.net"
    },
    booking: {
      title: "Записатися на прийом",
      selectDate: "Виберіть дату",
      selectTime: "Виберіть час",
      consultationType: "Тип консультації",
      confirmBooking: "Підтвердити запис",
      bookingConfirmed: "Запис підтверджено!",
      noSlotsAvailable: "Немає доступних слотів на цю дату"
    },
    dashboard: {
      welcome: "Ласкаво просимо",
      myAppointments: "Мої записи",
      upcomingAppointments: "Майбутні записи",
      pastAppointments: "Минулі записи",
      noAppointments: "Немає записів",
      status: {
        pending: "Очікує",
        confirmed: "Підтверджено",
        completed: "Завершено",
        cancelled: "Скасовано"
      },
      actions: {
        confirm: "Підтвердити",
        cancel: "Скасувати",
        complete: "Завершити",
        joinVideo: "Приєднатися до відео"
      }
    },
    common: {
      loading: "Завантаження...",
      error: "Виникла помилка",
      success: "Успішно",
      save: "Зберегти",
      cancel: "Скасувати",
      delete: "Видалити",
      edit: "Редагувати",
      back: "Назад",
      next: "Далі",
      previous: "Попередній",
      close: "Закрити",
      minutes: "хв",
      euro: "€"
    },
    payment: {
      paymentRequired: "Потрібна оплата",
      paymentDescription: "Завершіть бронювання, здійснивши оплату",
      processing: "Обробка...",
      success: "Оплата успішна!",
      failed: "Оплата не вдалася",
      cancelled: "Оплату скасовано",
      tryAgain: "Спробувати ще раз"
    },
    practitionerSignup: {
      title: "Стати спеціалістом",
      subtitle: "Приєднуйтесь до спільноти Opora Vie",
      backToHome: "Повернутися на головну",
      step1Title: "Крок 1: Запит доступу",
      step1Desc: "Заповніть вашу інформацію. Ми надішлемо вам код доступу електронною поштою.",
      step2Title: "Крок 2: Перевірка коду",
      step2Desc: "Код доступу було надіслано на вашу електронну пошту",
      step3Title: "Крок 3: Контракт спеціаліста",
      step3Desc: "Будь ласка, прочитайте та прийміть умови контракту",
      step5Title: "Крок 5: Створіть обліковий запис",
      step5Desc: "Завершіть реєстрацію, створивши облікові дані",
      firstName: "Ім'я",
      lastName: "Прізвище",
      email: "Email",
      phone: "Телефон",
      password: "Пароль",
      passwordMin: "символів мінімум",
      accessCode: "Код доступу",
      accessCodePlaceholder: "Введіть код, отриманий електронною поштою",
      sendRequest: "Надіслати мій запит",
      verifyCode: "Перевірити код",
      noCodeReceived: "Не отримали код?",
      resendRequest: "Надіслати повторно",
      downloadContract: "Завантажити контракт (PDF)",
      acceptTerms: "Я прочитав(ла) та приймаю загальні умови контракту доступу спеціаліста. Я розумію, що реєстраційний внесок у розмірі",
      willBeCharged: "буде стягнуто.",
      acceptAndPay: "Прийняти та оплатити",
      createAccount: "Створити обліковий запис спеціаліста",
      paymentReceived: "Оплату отримано - Контракт прийнято",
      alreadyAccount: "Вже є обліковий запис?",
      login: "Увійти",
      requestSent: "Запит надіслано! Ви отримаєте код електронною поштою.",
      codeVerified: "Код підтверджено! Будь ласка, прочитайте та прийміть контракт.",
      paymentSuccess: "Оплата успішна! Тепер створіть обліковий запис.",
      accountCreated: "Обліковий запис спеціаліста успішно створено!",
      mustAcceptTerms: "Ви повинні прийняти умови контракту",
      passwordTooShort: "Пароль повинен містити мінімум 16 символів",
      sending: "Надсилання...",
      verifying: "Перевірка...",
      redirectingPayment: "Перенаправлення на оплату...",
      creating: "Створення..."
    }
  },
  // Georgian (ქართული)
  ka: {
    // Navigation
    nav: {
      findPractitioner: "სპეციალისტის ძიება",
      home: "მთავარი",
      search: "ძიება",
      about: "ჩვენს შესახებ",
      login: "შესვლა",
      register: "რეგისტრაცია",
      logout: "გასვლა",
      dashboard: "პანელი",
      profile: "პროფილი",
      resources: "რესურსები",
      practicalInfo: "პრაქტიკული ინფო",
      blog: "ბლოგი / სიახლეები",
      credits: "კრედიტები",
      becomePractitioner: "გახდით პრაქტიკოსი",
      mySpace: "ჩემი სივრცე",
      myPractitionerProfile: "ჩემი პრაქტიკოსის პროფილი",
      resourcesGuides: "გზამკვლევები და რჩევები"
    },
    // Landing page
    landing: {
      badge: "პირველი გლობალური პორტალი აღმოსავლეთ ევროპის ალტერნატიული მედიცინის პრაქტიკოსებისთვის",
      title: "იპოვეთ თქვენი კეთილდღეობის პრაქტიკოსი",
      titleHighlight: "მსოფლიოს ნებისმიერ წერტილში",
      subtitle: "დატოვეთ თქვენი ქვეყანა, ცხოვრობთ შორს ოჯახისგან, განიცდით სტრესს ან რთულ პერიოდს? ჩვენ ვართ მოსმენის ხაზი - ჩვენი თერაპევტები, ნატუროპათები, სოფროლოგები და ფსიქოლოგები აქ არიან თქვენი მოსასმენად და თანხლებისთვის. ევროპაში იყოთ თუ სხვაგან მსოფლიოში - აღარ ხართ მარტო.",
      searchSpecialty: "სპეციალობა",
      searchSpecialtyPlaceholder: "აირჩიეთ სპეციალობა",
      searchCity: "ქალაქი",
      searchCityPlaceholder: "თბილისი, ბათუმი...",
      searchButton: "ძიება",
      easyBooking: "მარტივი ჯავშანი",
      easyBookingDesc: "24/7",
      heroTitle: "იპოვეთ თქვენი კეთილდღეობის სპეციალისტი",
      heroSubtitle: "თქვენ დატოვეთ თქვენი ქვეყანა, ცხოვრობთ შორს თქვენი ფესვებიდან და ხანდახან გრძნობთ მარტოსულობას... ჩვენი სპეციალისტები აქ არიან თქვენთვის.",
      searchPlaceholder: "ძიება ქალაქის მიხედვით...",
      allSpecialties: "ყველა სპეციალობა",
      allCountries: "ყველა ქვეყანა",
      specialtiesTitle: "ჩვენი სპეციალობები",
      specialtiesSubtitle: "კვალიფიციური პრაქტიკოსები, რომლებიც ესმით თქვენს კულტურას და ლაპარაკობენ თქვენს ენაზე",
      featuredTitle: "აღმოსაჩენი პრაქტიკოსები",
      featuredSubtitle: "ნახეთ ჩვენი პრაქტიკოსების პროფილები და დაჯავშნეთ შეხვედრა",
      viewAll: "ყველა პრაქტიკოსის ნახვა",
      perConsultation: "/ კონსულტაცია",
      whyChooseTitle: "რატომ უნდა აგვირჩიოთ?",
      whyChooseSubtitle: "პლატფორმა, რომელიც აახლოებს აღმოსავლეთიდან მოსულ საზოგადოებებს",
      feature1Title: "მხარდაჭერა და მოსმენა",
      feature1Desc: "ოჯახისგან განშორება, ახალ ქვეყანასთან ადაპტაცია, შფოთვა, პირადი ან პროფესიული პრობლემები - ჩვენი სპეციალისტები აქ არიან თქვენი მოსასმენად",
      feature2Title: "თქვენი კულტურის პრაქტიკოსები",
      feature2Desc: "იპოვეთ პრაქტიკოსები, რომლებიც ესმით თქვენს გზას, ლაპარაკობენ თქვენს ენაზე და იცნობენ თქვენს ტრადიციებს",
      feature3Title: "ხელმისაწვდომია ყველგან",
      feature3Desc: "კაბინეტში თუ ვიდეოკონფერენციით, ჩვენი პრაქტიკოსები თან გახლავთ მსოფლიოს ნებისმიერ წერტილში",
      ctaTitle: "თქვენ პრაქტიკოსი ხართ?",
      ctaSubtitle: "შეუერთდით აღმოსავლეთ ევროპის პრაქტიკოსების ჩვენს ქსელს. დაეხმარეთ თქვენს თანამემამულეებს მთელ მსოფლიოში.",
      ctaButton: "შექმენით ჩემი პრაქტიკოსის პროფილი",
      testimonialTitle: "რას ამბობენ ჩვენი მომხმარებლები",
      testimonialSubtitle: "აღმოაჩინეთ იმ ადამიანების მოწმობები, რომლებმაც მხარდაჭერა იპოვეს ჩვენი პრაქტიკოსების მეშვეობით",
      allRights: "ყველა უფლება დაცულია.",
      gdprCompliant: "GDPR შესაბამისი",
      dataProtection: "თქვენი მონაცემები დაცულია",
      securePayments: "უსაფრთხო გადახდები",
      poweredByStripe: "Stripe-ის მეშვეობით",
      sslEncrypted: "SSL დაშიფრული",
      secureConnection: "უსაფრთხო კავშირი"
    },
    // Testimonials
    testimonials: [
      {
        name: "ნინო გიორგაძე",
        location: "თბილისი",
        text: "Opora Vie-ის წყალობით ვიპოვე შესანიშნავი ნატუროპათი ჩემს მახლობლად. ჯავშანი მარტივი და სწრაფია!",
        rating: 5
      },
      {
        name: "გიორგი ბერიძე",
        location: "ბათუმი",
        text: "შესანიშნავი სერვისი! ჩემი სოფროლოგი ძალიან მეხმარება სტრესის მართვაში. გირჩევთ ამ პლატფორმას.",
        rating: 5
      },
      {
        name: "მარიამ წიკლაური",
        location: "ქუთაისი",
        text: "საბოლოოდ პლატფორმა, რომელიც აერთიანებს ყველა ალტერნატიული მედიცინის პრაქტიკოსს. ძალიან მოსახერხებელია შედარებისა და არჩევისთვის.",
        rating: 5
      }
    ],
    // Une Page
    une: {
      founders: "დამფუძნებლები",
      featured: "მთავარი",
      featuredSubtitle: "გაიცანით ჩვენი სპეციალისტები მათი პრეზენტაციის ვიდეოების მეშვეობით",
      noVideo: "ამჟამად მთავარი ვიდეო არ არის",
      ctaTitle: "შეუერთდით ჩვენს საზოგადოებას",
      ctaSubtitle: "ხართ თუ არა სპეციალისტი ან ეძებთ თანხლებას, Apora გაკავშირებთ კეთილდღეობის საუკეთესო პროფესიონალებთან.",
      findPractitioner: "იპოვეთ სპეციალისტი",
      becomePractitioner: "გახდით სპეციალისტი"
    },
    // Search Page
    search: {
      title: "იპოვეთ სპეციალისტი",
      practitionersAvailable: "სპეციალისტ(ებ)ი ხელმისაწვდომია",
      subtitle: "მოძებნეთ სპეციალისტები თქვენს მახლობლად",
      filters: "ფილტრები",
      clear: "წაშლა",
      specialty: "სპეციალობა",
      allSpecialties: "ყველა სპეციალობა",
      country: "ქვეყანა",
      allCountries: "ყველა ქვეყანა",
      region: "რეგიონი",
      allRegions: "ყველა რეგიონი",
      department: "დეპარტამენტი",
      allDepartments: "ყველა დეპარტამენტი",
      city: "ქალაქი",
      cityPlaceholder: "მოძებნეთ ქალაქი",
      location: "ადგილმდებარეობა",
      consultationType: "კონსულტაციის ტიპი",
      allTypes: "ყველა ტიპი",
      priceRange: "ფასის დიაპაზონი",
      languages: "ენები",
      results: "შედეგები",
      noResults: "სპეციალისტი ვერ მოიძებნა",
      noPractitionerFound: "სპეციალისტი ვერ მოიძებნა",
      tryDifferentCriteria: "სცადეთ სხვა კრიტერიუმები",
      loading: "იტვირთება...",
      viewProfile: "პროფილის ნახვა",
      bookNow: "დაჯავშნეთ ახლა",
      perSession: "სესიაზე",
      yearsExp: "წლის გამოცდილება",
      cabinet: "კაბინეტში",
      video: "ვიდეოთი",
      home: "სახლში",
      verified: "დამოწმებული",
      applyFilters: "ფილტრების გამოყენება",
      featuredPractitioners: "აღმოსაჩენი სპეციალისტები",
      clearFilters: "ფილტრების წაშლა",
      listView: "სია",
      mapView: "რუკა",
      noLocationAvailable: "არ არის ხელმისაწვდომი სპეციალისტი ლოკაციით"
    },
    // Auth Page
    auth: {
      welcome: "კეთილი იყოს თქვენი მობრძანება Opora Vie-ში",
      welcomeSubtitle: "იპოვეთ იდეალური სპეციალისტი თქვენი კეთილდღეობისთვის ან განავითარეთ თქვენი საქმიანობა.",
      backToHome: "მთავარზე დაბრუნება",
      login: "შესვლა",
      register: "რეგისტრაცია",
      welcomeBack: "კეთილი იყოს თქვენი დაბრუნება!",
      connectToAccount: "შედით თქვენს ანგარიშში",
      email: "ელფოსტა",
      emailProfessional: "პროფესიული ელფოსტა",
      password: "პაროლი",
      passwordMinChars: "მინიმუმ 6 სიმბოლო",
      loginButton: "შესვლა",
      createAccount: "ანგარიშის შექმნა",
      joinUs: "შეუერთდით Opora Vie-ს",
      joinPlatform: "შეუერთდით პლატფორმას წუთზე ნაკლებ დროში.",
      iAm: "მე ვარ",
      client: "კლიენტი",
      clientDesc: "ვეძებ სპეციალისტს",
      practitioner: "სპეციალისტი",
      practitionerDesc: "ვთავაზობ ჩემს მომსახურებას",
      iAmClient: "მე კლიენტი ვარ",
      iAmPractitioner: "მე სპეციალისტი ვარ",
      firstName: "სახელი",
      lastName: "გვარი",
      phone: "ტელეფონი",
      phoneOptional: "ტელეფონი (არასავალდებულო)",
      createMyAccount: "შექმენით ჩემი ანგარიში",
      identityVerification: "პირადობის დადასტურება",
      verificationExplanation: "შეიყვანეთ თქვენი სახელი და პროფესიული ელფოსტა. ჩვენ გამოგიგზავნით 8-სიმბოლოიან კოდს თქვენი რეგისტრაციის დასადასტურებლად (მოქმედებს 7 დღე).",
      sendMyCode: "გამოაგზავნეთ ჩემი კოდი",
      codeReceived: "კოდი გაგზავნილია!",
      checkEmail: "კოდი გაგზავნილია თქვენს ელფოსტაზე. შეამოწმეთ სპამის საქაღალდეც.",
      accessCode: "წვდომის კოდი",
      verifyCode: "კოდის დადასტურება",
      resendCode: "← კოდის ხელახლა გაგზავნა",
      codeVerifiedSuccess: "კოდი წარმატებით დადასტურდა!",
      createYourPassword: "ახლა შექმენით თქვენი პაროლი.",
      alreadyHaveAccount: "უკვე გაქვთ ანგარიში?",
      loginLink: "შესვლა",
      gdprCompliant: "GDPR შესაბამისი",
      securePayments: "უსაფრთხო გადახდები Stripe-ით",
      dataProtection: "მონაცემთა დაცვა",
      practitionerSignupTitle: "სპეციალისტის რეგისტრაცია",
      practitionerSignupSubtitle: "შექმენით ანგარიში კლიენტების მისაღებად",
      joinOpora: "შეუერთდით Opora Vie-ს",
      joinOporaSubtitle: "განავითარეთ თქვენი საქმიანობა და დაუკავშირდით კლიენტებს, რომლებიც ეძებენ თქვენს მომსახურებას.",
      benefit1Title: "გაზრდილი ხილვადობა",
      benefit1Desc: "იპოვონ კლიენტებმა თქვენს რეგიონში",
      benefit2Title: "გამარტივებული მართვა",
      benefit2Desc: "მარტივად მართეთ შეხვედრები და განრიგი",
      benefit3Title: "ონლაინ კონსულტაციები",
      benefit3Desc: "ჩაატარეთ სესიები ვიდეოკავშირით",
      benefit4Title: "უსაფრთხო გადახდა",
      benefit4Desc: "მიიღეთ ონლაინ გადახდები Stripe-ით",
      createPractitionerAccount: "შექმენით სპეციალისტის ანგარიში",
      creatingAccount: "იქმნება ანგარიში...",
      alreadyRegistered: "უკვე დარეგისტრირებული ხართ?"
    },
    // Practitioner Profile
    practitioner: {
      about: "შესახებ",
      specialties: "სპეციალობები",
      consultationTypes: "კონსულტაციის ტიპები",
      languages: "ენები",
      experience: "გამოცდილება",
      diplomas: "დიპლომები და სერთიფიკატები",
      location: "ადგილმდებარეობა",
      price: "ტარიფი",
      duration: "ხანგრძლივობა",
      bookAppointment: "დაჯავშნეთ შეხვედრა",
      contactPractitioner: "დაუკავშირდით სპეციალისტს",
      verified: "დამოწმებული სპეციალისტი",
      memberSince: "წევრი დან",
      yearsExperience: "წლის გამოცდილება",
      minutes: "წუთი",
      reviews: "მიმოხილვები",
      noReviews: "ჯერ მიმოხილვები არ არის"
    },
    // Booking
    booking: {
      title: "შეხვედრის დაჯავშნა",
      selectDate: "აირჩიეთ თარიღი",
      selectTime: "აირჩიეთ დრო",
      selectType: "კონსულტაციის ტიპი",
      yourInfo: "თქვენი ინფორმაცია",
      message: "შეტყობინება სპეციალისტისთვის",
      messagePlaceholder: "აღწერეთ კონსულტაციის მიზეზი...",
      confirm: "დაჯავშნა",
      confirmation: "დაჯავშნის დასტური",
      confirmed: "თქვენი შეხვედრა დადასტურებულია",
      pending: "მოლოდინში დასტურისთვის",
      cancelled: "გაუქმებულია",
      noSlots: "ამ თარიღზე ხელმისაწვდომი სლოტი არ არის",
      cabinet: "კაბინეტში",
      video: "ვიდეოკონსულტაცია",
      home: "სახლში ვიზიტი"
    },
    // Dashboard
    dashboard: {
      welcome: "კეთილი იყოს თქვენი მობრძანება",
      upcoming: "მომავალი შეხვედრები",
      past: "წარსული შეხვედრები",
      noAppointments: "შეხვედრები არ არის",
      viewAll: "ყველას ნახვა",
      profile: "ჩემი პროფილი",
      settings: "პარამეტრები",
      stats: "სტატისტიკა",
      totalAppointments: "სულ შეხვედრები",
      completedAppointments: "დასრულებული",
      pendingAppointments: "მოლოდინში",
      cancelledAppointments: "გაუქმებული",
      revenue: "შემოსავალი",
      thisMonth: "ეს თვე",
      joinVideoCall: "შეუერთდით ვიდეოზარს",
      cancelAppointment: "შეხვედრის გაუქმება",
      reschedule: "გადატვირთვა"
    },
    // About page
    about: {
      title: "ჩვენს შესახებ",
      mission: "ჩვენი მისია",
      missionText: "Opora Vie შეიქმნა აღმოსავლეთ ევროპის ექსპატრიანტებისთვის, რომლებიც ეძებენ კეთილდღეობის სპეციალისტებს, რომლებიც ესმით მათ კულტურასა და ენას.",
      values: "ჩვენი ღირებულებები",
      value1Title: "მოსმენა",
      value1Desc: "ყოველი ადამიანი უნიკალურია და იმსახურებს ყურადღებიან მოსმენას",
      value2Title: "ხარისხი",
      value2Desc: "ჩვენი სპეციალისტები შერჩეულია მათი გამოცდილებისა და ადამიანური თვისებების მიხედვით",
      value3Title: "ხელმისაწვდომობა",
      value3Desc: "კეთილდღეობა ყველასთვის ხელმისაწვდომი უნდა იყოს, ყველგან",
      team: "ჩვენი გუნდი",
      contact: "დაგვიკავშირდით"
    },
    // Common
    common: {
      loading: "იტვირთება...",
      error: "შეცდომა",
      success: "წარმატება",
      save: "შენახვა",
      cancel: "გაუქმება",
      delete: "წაშლა",
      edit: "რედაქტირება",
      close: "დახურვა",
      confirm: "დადასტურება",
      back: "უკან",
      next: "შემდეგი",
      previous: "წინა",
      search: "ძიება",
      filter: "ფილტრი",
      sort: "დალაგება",
      all: "ყველა",
      none: "არცერთი",
      yes: "დიახ",
      no: "არა",
      or: "ან",
      and: "და",
      from: "დან",
      to: "მდე",
      date: "თარიღი",
      time: "დრო",
      status: "სტატუსი",
      actions: "მოქმედებები",
      details: "დეტალები",
      description: "აღწერა",
      name: "სახელი",
      email: "ელფოსტა",
      phone: "ტელეფონი",
      address: "მისამართი",
      city: "ქალაქი",
      country: "ქვეყანა",
      required: "სავალდებულო",
      optional: "არასავალდებულო"
    },
    // Testimonials
    testimonials: [
      {
        name: "ნინო მ.",
        role: "კლიენტი",
        text: "დიდი ხანია ვეძებდი ფსიქოლოგს, ვინც ქართულად ლაპარაკობს. Opora Vie-ის წყალობით ვიპოვე სრულყოფილი თანხლება."
      },
      {
        name: "გიორგი კ.",
        role: "კლიენტი",
        text: "ვიდეოკონსულტაციები ძალიან მოსახერხებელია, როცა საზღვარგარეთ ხარ. გირჩევთ!"
      },
      {
        name: "მარიამ ს.",
        role: "ნატუროპათი",
        text: "როგორც სპეციალისტმა, ამ პლატფორმამ საშუალება მომცა ჩემს საზოგადოებას მივწვდე მთელ მსოფლიოში."
      }
    ],
    // Practitioner Signup
    practitionerSignup: {
      title: "გახდით სპეციალისტი Opora Vie-ზე",
      subtitle: "შეუერთდით ჩვენს ქსელს და დაუკავშირდით კლიენტებს, რომლებიც ეძებენ თქვენს გამოცდილებას",
      step1: "მოთხოვნა",
      step2: "დადასტურება",
      step3: "კონტრაქტი",
      step4: "ანგარიში",
      enterInfo: "შეიყვანეთ თქვენი ინფორმაცია",
      enterCode: "შეიყვანეთ მიღებული კოდი",
      readContract: "წაიკითხეთ და მიიღეთ კონტრაქტი",
      createAccount: "შექმენით თქვენი ანგარიში",
      firstName: "სახელი",
      lastName: "გვარი",
      email: "პროფესიული ელფოსტა",
      code: "წვდომის კოდი",
      codeHelp: "შეიყვანეთ ელფოსტით მიღებული 8-სიმბოლოიანი კოდი",
      acceptTerms: "ვეთანხმები კონტრაქტის პირობებს",
      password: "პაროლი",
      passwordHelp: "მინიმუმ 6 სიმბოლო",
      submit: "გაგზავნა",
      verify: "დადასტურება",
      accept: "მიღება და გაგრძელება",
      create: "ანგარიშის შექმნა",
      login: "შესვლა",
      requestSent: "მოთხოვნა გაგზავნილია! თქვენ მიიღებთ კოდს ელფოსტით.",
      codeVerified: "კოდი დადასტურებულია! გთხოვთ წაიკითხოთ და მიიღოთ კონტრაქტი.",
      paymentSuccess: "გადახდა წარმატებულია! ახლა შექმენით თქვენი ანგარიში.",
      accountCreated: "სპეციალისტის ანგარიში წარმატებით შეიქმნა!",
      mustAcceptTerms: "თქვენ უნდა მიიღოთ კონტრაქტის პირობები",
      passwordTooShort: "პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს",
      sending: "იგზავნება...",
      verifying: "დასტურდება...",
      redirectingPayment: "გადამისამართება გადახდაზე...",
      creating: "იქმნება..."
    }
  }
};

export const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  { code: 'ka', name: 'ქართული', flag: '🇬🇪' }
];

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang] || translations['fr'];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
